package com.havn.app.features.settings.presentation

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Canvas
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.foundation.rememberScrollState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Surface
import androidx.compose.material3.Switch
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.PasswordVisualTransformation
import androidx.compose.ui.unit.dp
import androidx.compose.foundation.text.KeyboardOptions
import com.havn.app.core.billing.HavnBillingCustomerState
import com.havn.app.core.billing.HavnBillingPeriod
import com.havn.app.core.billing.HavnBillingService
import com.havn.app.core.billing.HavnPlans
import com.havn.app.core.billing.HavnPurchasePendingException
import com.havn.app.core.billing.HavnStorePlanOption
import com.havn.app.core.billing.HavnStorePlans
import com.havn.app.core.presentation.havnFriendlyMessage
import com.havn.app.core.designsystem.HavnBackground
import com.havn.app.core.designsystem.HavnButton
import com.havn.app.core.designsystem.HavnButtonStyle
import com.havn.app.core.designsystem.HavnCard
import com.havn.app.core.designsystem.HavnCardBorder
import com.havn.app.core.designsystem.HavnDanger
import com.havn.app.core.designsystem.HavnGold
import com.havn.app.core.designsystem.HavnIcon
import com.havn.app.core.designsystem.HavnIconKey
import com.havn.app.core.designsystem.HavnLeadCard
import com.havn.app.core.designsystem.HavnListFilterChip
import com.havn.app.core.designsystem.HavnPropertyCard
import com.havn.app.core.designsystem.HavnPushNavigation
import com.havn.app.core.designsystem.HavnScreenFrame
import com.havn.app.core.designsystem.HavnSearchField
import com.havn.app.core.designsystem.HavnSpacing
import com.havn.app.core.designsystem.HavnStatCard
import com.havn.app.core.designsystem.HavnStatus
import com.havn.app.core.designsystem.HavnStatusBadge
import com.havn.app.core.designsystem.HavnSurfaceElevated
import com.havn.app.core.designsystem.HavnTextMuted
import com.havn.app.core.designsystem.HavnTextPrimary
import com.havn.app.core.designsystem.HavnTextSecondary
import com.havn.app.core.designsystem.HavnTextField
import com.havn.app.core.designsystem.havnIsWebShell
import com.havn.app.core.localization.HavnLanguage
import com.havn.app.core.localization.HavnLanguageRepository
import com.havn.app.core.localization.HavnStrings
import com.havn.app.core.localization.LocalHavnLanguage
import com.havn.app.core.localization.LocalHavnStrings
import com.havn.app.core.media.HavnDatabaseImage
import com.havn.app.core.media.HavnPhotoPicker
import com.havn.app.core.media.havnAgentAvatarPreviewSource
import com.havn.app.core.platform.HavnClipboard
import com.havn.app.core.platform.HavnExternalActions
import com.havn.app.core.platform.HavnSubscriptionDisclosurePlatform
import com.havn.app.core.platform.havnSubscriptionDisclosurePlatform
import com.havn.app.core.settings.HavnCurrency
import com.havn.app.core.settings.HavnMeasurementSystem
import com.havn.app.core.settings.HavnUnitPreferencesRepository
import com.havn.app.core.settings.HavnKioskSecurityRepository
import com.havn.app.features.agency.domain.Agency
import com.havn.app.features.agency.domain.HavnSubscriptionTier
import com.havn.app.features.agency.domain.SubscriptionTransferRequest
import com.havn.app.features.agency.domain.UserEntitlement
import com.havn.app.features.agency.presentation.AgencyUiState
import com.havn.app.features.agency.presentation.AgencyViewModel
import com.havn.app.features.auth.domain.AuthRepository
import com.havn.app.features.auth.domain.AuthState
import com.havn.app.features.notifications.domain.HavnNotificationPreferences
import com.havn.app.features.notifications.domain.HavnNotificationSettings
import com.havn.app.features.notifications.domain.HavnNotificationType
import com.havn.app.features.notifications.domain.NotificationRepository
import com.havn.app.features.settings.domain.McpApiKey
import com.havn.app.features.settings.domain.McpApiKeyRepository
import com.havn.app.ui.theme.HavnThemeCatalog
import com.havn.app.ui.theme.HavnThemeManager
import com.havn.app.ui.theme.HavnThemeTokens
import com.havn.app.ui.theme.HavnThemeType
import com.havn.app.ui.theme.LocalHavnThemeTokens
import com.havn.app.ui.theme.asAppearanceTheme
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch

@Composable
fun SettingsScreen(
    authRepository: AuthRepository,
    agencyViewModel: AgencyViewModel,
    languageRepository: HavnLanguageRepository,
    unitPreferencesRepository: HavnUnitPreferencesRepository,
    kioskSecurityRepository: HavnKioskSecurityRepository,
    mcpApiKeyRepository: McpApiKeyRepository,
    themeManager: HavnThemeManager,
    notificationRepository: NotificationRepository,
    billingService: HavnBillingService,
    photoPicker: HavnPhotoPicker,
    openPurchaseOnStart: Boolean = false,
    purchaseBackToToday: Boolean = false,
    onPurchaseStartConsumed: () -> Unit = {},
    onAgentProfileChanged: () -> Unit = {},
    onBack: () -> Unit = {},
    onLogout: () -> Unit = {},
    onDeleteAccount: () -> Unit = {}
) {
    val strings = LocalHavnStrings.current
    val authState by authRepository.authState.collectAsState()
    val agencyState by agencyViewModel.uiState.collectAsState()
    val selectedLanguage by languageRepository.language.collectAsState()
    val unitPreferences by unitPreferencesRepository.preferences.collectAsState()
    val kioskPin by kioskSecurityRepository.pin.collectAsState()
    val selectedTheme by themeManager.themeType.collectAsState()
    val theme = LocalHavnThemeTokens.current
    val scope = rememberCoroutineScope()
    val userId = (authState as? AuthState.LoggedIn)?.user?.id
    val userEmail = (authState as? AuthState.LoggedIn)?.user?.email?.trim().orEmpty()
    val isStoreReviewAccount = userEmail.isStoreReviewAccountEmail()
    var firstName by remember(userId) { mutableStateOf("") }
    var lastName by remember(userId) { mutableStateOf("") }
    var avatarDataUrl by remember(userId) { mutableStateOf<String?>(null) }
    var profileError by remember(userId) { mutableStateOf<String?>(null) }
    var isSavingProfile by remember(userId) { mutableStateOf(false) }
    var isUploadingPhoto by remember(userId) { mutableStateOf(false) }
    var settingsScreen by remember { mutableStateOf(SettingsSubScreen.Main) }
    var notificationPreferences by remember(userId) { mutableStateOf(HavnNotificationPreferences()) }
    var notificationError by remember(userId) { mutableStateOf<String?>(null) }
    var mcpApiKeys by remember(userId, agencyState.selectedAgencyId) { mutableStateOf<List<McpApiKey>>(emptyList()) }
    var newlyCreatedMcpKey by remember(userId, agencyState.selectedAgencyId) { mutableStateOf<String?>(null) }
    var mcpKeyVisible by remember(userId, agencyState.selectedAgencyId) { mutableStateOf(false) }
    var mcpCopied by remember(userId, agencyState.selectedAgencyId) { mutableStateOf(false) }
    var isLoadingMcpKey by remember(userId, agencyState.selectedAgencyId) { mutableStateOf(false) }
    var isRotatingMcpKey by remember(userId, agencyState.selectedAgencyId) { mutableStateOf(false) }
    var mcpKeyError by remember(userId, agencyState.selectedAgencyId) { mutableStateOf<String?>(null) }
    var showSignOutDialog by remember { mutableStateOf(false) }
    var showDeleteAccountDialog by remember { mutableStateOf(false) }
    var upgradePrompt by remember { mutableStateOf<String?>(null) }
    var purchaseConfirmation by remember { mutableStateOf<PurchaseConfirmationKind?>(null) }
    var showTransferSuccess by remember { mutableStateOf(false) }
    val desktopButtonModifier = Modifier.fillMaxWidth()
    val canUseMcp = true

    LaunchedEffect(userId) {
        if (userId != null) {
            authRepository.agentProfile(userId)
                .onSuccess {
                    firstName = it.firstName
                    lastName = it.lastName
                    avatarDataUrl = it.avatarDataUrl
                    profileError = null
                }
                .onFailure { profileError = it.message }
            notificationRepository.preferences(userId)
                .onSuccess {
                    notificationPreferences = it
                    notificationError = null
                }
                .onFailure { notificationError = it.message }
        }
    }

    LaunchedEffect(userId, agencyState.selectedAgencyId) {
        if (userId != null) {
            isLoadingMcpKey = true
            mcpApiKeyRepository.listKeys(agencyState.selectedAgencyId)
                .onSuccess {
                    mcpApiKeys = it
                    mcpKeyError = null
                }
                .onFailure { mcpKeyError = it.message }
            isLoadingMcpKey = false
        }
    }

    LaunchedEffect(openPurchaseOnStart) {
        if (openPurchaseOnStart) {
            settingsScreen = SettingsSubScreen.Purchase
            onPurchaseStartConsumed()
        }
    }

    HavnPushNavigation(
        targetState = settingsScreen,
        depthFor = SettingsSubScreen::depth,
        modifier = Modifier.fillMaxSize()
    ) { visibleScreen ->
        when (visibleScreen) {
            SettingsSubScreen.Purchase -> PurchaseScreen(
                billingService = billingService,
                userId = userId,
                backLabel = if (purchaseBackToToday) strings.navToday else strings.settingsTitle,
                onPurchaseCompleted = { customerState, confirmationKind, expectedTier ->
                    agencyViewModel.syncRevenueCatSubscriptionWithExpectedTier(
                        fallbackTier = maxSubscriptionTier(customerState.tier, expectedTier),
                        expectedTier = expectedTier
                    )
                        .map {
                            purchaseConfirmation = confirmationKind
                            settingsScreen = SettingsSubScreen.Main
                            Unit
                        }
                },
                onBack = if (purchaseBackToToday) onBack else ({ settingsScreen = SettingsSubScreen.Main })
            )
            SettingsSubScreen.ThemeShowcase -> ThemeShowcaseScreen(onBack = { settingsScreen = SettingsSubScreen.Main })
            SettingsSubScreen.TransferPlan -> TransferPlanScreen(
                onCreateTransfer = { targetEmail ->
                    agencyViewModel.syncRevenueCatSubscription(agencyState.entitlement.tier)
                        .fold(
                            onSuccess = { agencyViewModel.createSubscriptionTransfer(targetEmail) },
                            onFailure = { Result.failure(it) }
                        )
                },
                onConfirmTransfer = { requestId, sourceCode, targetCode ->
                    agencyViewModel.confirmSubscriptionTransfer(requestId, sourceCode, targetCode)
                        .onSuccess {
                            showTransferSuccess = true
                            settingsScreen = SettingsSubScreen.Main
                        }
                },
                onBack = { settingsScreen = SettingsSubScreen.Main }
            )
            SettingsSubScreen.Notifications -> NotificationsSettingsScreen(
                preferences = notificationPreferences,
                error = notificationError,
                onPreferenceChanged = { type, enabled ->
                    notificationPreferences = notificationPreferences.copy(
                        enabledByType = notificationPreferences.enabledByType + (type to enabled)
                    )
                    scope.launch {
                        notificationRepository.setPreference(type, enabled)
                            .onFailure { notificationError = it.message }
                    }
                },
                onQuietHoursChanged = { settings ->
                    notificationPreferences = notificationPreferences.copy(settings = settings)
                    scope.launch {
                        notificationRepository.setQuietHours(settings)
                            .onFailure { notificationError = it.message }
                    }
                },
                onBack = { settingsScreen = SettingsSubScreen.Main }
            )
            SettingsSubScreen.CreateAgency -> CreateAgencyScreen(
                state = agencyState,
                onAgencyNameChanged = agencyViewModel::onAgencyNameChanged,
                onCreateAgency = agencyViewModel::createAgency,
                onDismissError = agencyViewModel::clearError,
                onBack = { settingsScreen = SettingsSubScreen.Main }
            )
            SettingsSubScreen.Main -> HavnScreenFrame(
                eyebrow = "",
                subtitle = "",
                title = strings.settingsTitle,
                backLabel = strings.back,
                onBack = onBack
            ) {
                Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                    HavnCard {
                        Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
                            Text(strings.agentProfileTitle, color = theme.primaryText, style = MaterialTheme.typography.titleLarge)
                            if (userEmail.isNotBlank()) {
                                Text(
                                    text = userEmail,
                                    color = theme.mutedText,
                                    style = MaterialTheme.typography.bodyMedium
                                )
                            }
                            Row(
                                modifier = Modifier.fillMaxWidth(),
                                verticalAlignment = Alignment.CenterVertically,
                                horizontalArrangement = Arrangement.spacedBy(HavnSpacing.md)
                            ) {
                                Box(
                                    modifier = Modifier
                                        .size(72.dp)
                                        .clip(CircleShape)
                                        .background(theme.surface),
                                    contentAlignment = Alignment.Center
                                ) {
                                    val rendered = HavnDatabaseImage(
                                        dataUrl = avatarDataUrl,
                                        previewDataUrl = havnAgentAvatarPreviewSource(avatarDataUrl, 112),
                                        contentDescription = strings.agentPhoto,
                                        modifier = Modifier.fillMaxSize(),
                                        contentScale = androidx.compose.ui.layout.ContentScale.Crop
                                    )
                                    if (!rendered) {
                                        HavnIcon(
                                            icon = HavnIconKey.User,
                                            contentDescription = null,
                                            tint = theme.primaryAccent,
                                            modifier = Modifier.size(32.dp)
                                        )
                                    }
                                }
                                HavnButton(
                                    text = if (isUploadingPhoto) strings.uploading else strings.addPhoto,
                                    onClick = {
                                        val currentUserId = userId
                                        if (currentUserId != null) {
                                            photoPicker.pick { photo ->
                                                if (photo == null || photo.bytes.isEmpty()) {
                                                    profileError = strings.validAgentPhotoRequired
                                                    return@pick
                                                }
                                                isUploadingPhoto = true
                                                scope.launch {
                                                    authRepository.updateAgentPhoto(currentUserId, photo)
                                                        .onSuccess {
                                                            avatarDataUrl = it.avatarDataUrl
                                                            profileError = null
                                                            onAgentProfileChanged()
                                                        }
                                                        .onFailure { profileError = it.message }
                                                    isUploadingPhoto = false
                                                }
                                            }
                                        }
                                    },
                                    modifier = Modifier.weight(1f),
                                    style = HavnButtonStyle.Secondary,
                                    enabled = !isUploadingPhoto && userId != null,
                                    loading = isUploadingPhoto,
                                    leadingIcon = HavnIconKey.Plus
                                )
                            }
                            HavnTextField(
                                value = firstName,
                                onValueChange = {
                                    firstName = it
                                    profileError = null
                                },
                                label = strings.firstName,
                                keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Text)
                            )
                            HavnTextField(
                                value = lastName,
                                onValueChange = {
                                    lastName = it
                                    profileError = null
                                },
                                label = strings.lastName,
                                keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Text)
                            )
                            HavnButton(
                                text = if (isSavingProfile) strings.saving else strings.commonSave,
                                modifier = desktopButtonModifier,
                                enabled = !isSavingProfile && userId != null,
                                loading = isSavingProfile,
                                onClick = {
                                    val currentUserId = userId
                                    if (currentUserId != null) {
                                        isSavingProfile = true
                                        scope.launch {
                                            authRepository.updateAgentProfile(currentUserId, firstName, lastName)
                                                .onSuccess {
                                                    firstName = it.firstName
                                                    lastName = it.lastName
                                                    profileError = null
                                                    onAgentProfileChanged()
                                                }
                                                .onFailure { profileError = it.message }
                                            isSavingProfile = false
                                        }
                                    }
                                }
                            )
                            profileError?.let {
                                Text(text = it, color = HavnDanger, style = MaterialTheme.typography.labelLarge)
                            }
                        }
                    }
                    AgentPlanCard(
                        planName = agencyState.entitlement.tier.databaseValue
                            .split("_")
                            .joinToString(" ") { part -> part.replaceFirstChar { it.uppercase() } },
                        canTransferPlan = agencyState.entitlement.tier != HavnSubscriptionTier.Free,
                        onUpgradePlan = { settingsScreen = SettingsSubScreen.Purchase },
                        onTransferPlan = { settingsScreen = SettingsSubScreen.TransferPlan },
                        onRestorePurchase = {
                            val currentUserId = userId
                            if (currentUserId != null) {
                                scope.launch {
                                    billingService.restorePurchases(currentUserId)
                                        .onSuccess { customerState ->
                                            if (customerState.hasActiveHavnSubscription) {
                                                agencyViewModel.syncRevenueCatSubscription(customerState.tier)
                                                    .onSuccess {
                                                        purchaseConfirmation = PurchaseConfirmationKind.Restore
                                                    }
                                                    .onFailure { upgradePrompt = it.message }
                                            } else {
                                                upgradePrompt = strings.noActiveSubscriptionFound
                                            }
                                        }
                                        .onFailure { upgradePrompt = purchaseUserMessage(it, strings, PurchaseConfirmationKind.Restore) }
                                }
                            }
                        }
                    )
                    if (havnIsWebShell) {
                        AppearanceCard(
                            selectedTheme = selectedTheme.asAppearanceTheme(),
                            onThemeSelected = { theme ->
                                themeManager.setTheme(type = theme, canUsePremiumThemes = true)
                            },
                            onPreview = { settingsScreen = SettingsSubScreen.ThemeShowcase }
                        )
                    }
                    HavnCard {
                        Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
                            Text(text = strings.languageTitle, color = theme.primaryText, style = MaterialTheme.typography.titleLarge)
                            Text(text = strings.languageBody, color = theme.secondaryText, style = MaterialTheme.typography.bodyMedium)
                            LanguageComboBox(
                                selectedLanguage = selectedLanguage,
                                onLanguageSelected = languageRepository::setLanguage
                            )
                        }
                    }
                    HavnCard {
                        Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
                            Text(text = strings.notificationsTitle, color = theme.primaryText, style = MaterialTheme.typography.titleLarge)
                            Text(
                                text = strings.notificationsBody,
                                color = theme.secondaryText,
                                style = MaterialTheme.typography.bodyMedium
                            )
                            HavnButton(
                                text = strings.notificationSettings,
                                onClick = { settingsScreen = SettingsSubScreen.Notifications },
                                style = HavnButtonStyle.Secondary,
                                modifier = desktopButtonModifier,
                                leadingIcon = HavnIconKey.Alert
                            )
                            notificationError?.let {
                                Text(text = it, color = HavnDanger, style = MaterialTheme.typography.labelLarge)
                            }
                        }
                    }
                    HavnCard {
                        Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
                            Text(text = strings.unitsTitle, color = theme.primaryText, style = MaterialTheme.typography.titleLarge)
                            Text(text = strings.unitsBody, color = theme.secondaryText, style = MaterialTheme.typography.bodyMedium)
                            Text(text = strings.measurementSystemTitle, color = theme.mutedText, style = MaterialTheme.typography.labelLarge)
                            MeasurementSegmentedControl(
                                selectedSystem = unitPreferences.measurementSystem,
                                onSystemSelected = unitPreferencesRepository::setMeasurementSystem
                            )
                            Text(text = strings.currencyTitle, color = theme.mutedText, style = MaterialTheme.typography.labelLarge)
                            CurrencyComboBox(
                                selectedCurrency = unitPreferences.currency,
                                onCurrencySelected = unitPreferencesRepository::setCurrency
                            )
                        }
                    }
                    HavnCard {
                        Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
                            Text(text = strings.kioskSecurityTitle, color = theme.primaryText, style = MaterialTheme.typography.titleLarge)
                            Text(text = strings.kioskSecurityBody, color = theme.secondaryText, style = MaterialTheme.typography.bodyMedium)
                            HavnTextField(
                                value = kioskPin,
                                onValueChange = { kioskSecurityRepository.setPin(it) },
                                label = strings.kioskPinLabel,
                                visualTransformation = PasswordVisualTransformation(),
                                keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.NumberPassword)
                            )
                        }
                    }
                    McpApiKeyCard(
                        keys = mcpApiKeys,
                        revealedKey = newlyCreatedMcpKey,
                        keyVisible = mcpKeyVisible,
                        copied = mcpCopied,
                        loading = isLoadingMcpKey,
                        rotating = isRotatingMcpKey,
                        canUseMcp = canUseMcp,
                        error = mcpKeyError,
                        onRevealChanged = {
                            mcpKeyVisible = it
                            mcpCopied = false
                        },
                        onCopy = { key ->
                            mcpCopied = HavnClipboard.copyText(key)
                        },
                        onRotate = {
                            if (!canUseMcp) {
                                upgradePrompt = strings.mcpUpgradePrompt
                            } else {
                                isRotatingMcpKey = true
                                mcpKeyError = null
                                mcpCopied = false
                                scope.launch {
                                    mcpApiKeyRepository.createOrRotateKey(agencyState.selectedAgencyId, "HAVN MCP")
                                        .onSuccess { created ->
                                            newlyCreatedMcpKey = created.apiKey
                                            mcpKeyVisible = true
                                            mcpApiKeys = listOf(created) + mcpApiKeys.map {
                                                if (it.revokedAt == null) it.copy(revokedAt = created.createdAt) else it
                                            }
                                            mcpKeyError = null
                                        }
                                        .onFailure { mcpKeyError = it.message }
                                    isRotatingMcpKey = false
                                }
                            }
                        },
                        onRevoke = { key ->
                            isRotatingMcpKey = true
                            mcpKeyError = null
                            scope.launch {
                                mcpApiKeyRepository.revokeKey(key.id)
                                    .onSuccess {
                                        mcpApiKeys = mcpApiKeys.map { existing ->
                                            if (existing.id == key.id) existing.copy(revokedAt = "revoked") else existing
                                        }
                                        newlyCreatedMcpKey = null
                                        mcpKeyVisible = false
                                    }
                                    .onFailure { mcpKeyError = it.message }
                                isRotatingMcpKey = false
                            }
                        }
                    )
                    HavnButton(
                        text = strings.signOut,
                        onClick = { showSignOutDialog = true },
                        modifier = desktopButtonModifier,
                        style = HavnButtonStyle.Danger,
                        leadingIcon = HavnIconKey.LogOut
                    )
                    HavnButton(
                        text = strings.deleteAccount,
                        onClick = { showDeleteAccountDialog = true },
                        modifier = desktopButtonModifier,
                        style = HavnButtonStyle.Danger,
                        leadingIcon = HavnIconKey.Alert
                    )
                }

                if (showSignOutDialog) {
                    AlertDialog(
                        onDismissRequest = { showSignOutDialog = false },
                        containerColor = theme.card,
                        title = {
                            Text(strings.signOutQuestion, color = theme.primaryText, style = MaterialTheme.typography.titleLarge)
                        },
                        text = {
                            Text(
                                strings.signOutConfirmation,
                                color = theme.secondaryText,
                                style = MaterialTheme.typography.bodyMedium
                            )
                        },
                        confirmButton = {
                            TextButton(
                                onClick = {
                                    showSignOutDialog = false
                                    onLogout()
                                }
                            ) {
                                Text(strings.signOut, color = HavnDanger)
                            }
                        },
                        dismissButton = {
                            TextButton(onClick = { showSignOutDialog = false }) {
                                Text(strings.commonCancel, color = theme.primaryAccent)
                            }
                        }
                    )
                }
                if (showDeleteAccountDialog) {
                    AlertDialog(
                        onDismissRequest = { showDeleteAccountDialog = false },
                        containerColor = theme.card,
                        title = {
                            Text(
                                text = if (isStoreReviewAccount) strings.deleteAccountReviewTitle else strings.deleteAccountQuestion,
                                color = theme.primaryText,
                                style = MaterialTheme.typography.titleLarge
                            )
                        },
                        text = {
                            Text(
                                if (isStoreReviewAccount) strings.deleteAccountReviewBody else strings.deleteAccountOpenPageBody,
                                color = theme.secondaryText,
                                style = MaterialTheme.typography.bodyMedium
                            )
                        },
                        confirmButton = {
                            if (isStoreReviewAccount) {
                                TextButton(onClick = { showDeleteAccountDialog = false }) {
                                    Text(strings.ok, color = theme.primaryAccent)
                                }
                            } else {
                                TextButton(
                                    onClick = {
                                        showDeleteAccountDialog = false
                                        onDeleteAccount()
                                    }
                                ) {
                                    Text(strings.deleteAccount, color = HavnDanger)
                                }
                            }
                        },
                        dismissButton = {
                            if (!isStoreReviewAccount) {
                                TextButton(onClick = { showDeleteAccountDialog = false }) {
                                    Text(strings.commonCancel, color = theme.primaryAccent)
                                }
                            }
                        }
                    )
                }
                upgradePrompt?.let { message ->
                    AlertDialog(
                        onDismissRequest = { upgradePrompt = null },
                        containerColor = theme.card,
                        title = { Text(strings.restorePurchase, color = theme.primaryText, style = MaterialTheme.typography.titleLarge) },
                        text = { Text(message, color = theme.secondaryText, style = MaterialTheme.typography.bodyMedium) },
                        confirmButton = {
                            TextButton(onClick = {
                                upgradePrompt = null
                            settingsScreen = SettingsSubScreen.Purchase
                        }) {
                                Text(strings.upgrade, color = theme.primaryAccent)
                            }
                        },
                        dismissButton = {
                            TextButton(onClick = { upgradePrompt = null }) {
                                Text(strings.commonCancel, color = theme.secondaryText)
                            }
                        }
                    )
                }
                purchaseConfirmation?.let { confirmation ->
                    AlertDialog(
                        onDismissRequest = { purchaseConfirmation = null },
                        containerColor = theme.card,
                        title = {
                            Text(
                                text = when (confirmation) {
                                    PurchaseConfirmationKind.Purchase -> strings.purchaseSuccessTitle
                                    PurchaseConfirmationKind.Restore -> strings.restoreSuccessTitle
                                },
                                color = theme.primaryText,
                                style = MaterialTheme.typography.titleLarge
                            )
                        },
                        text = {
                            Text(
                                text = when (confirmation) {
                                    PurchaseConfirmationKind.Purchase -> strings.purchaseSuccessBody
                                    PurchaseConfirmationKind.Restore -> strings.restoreSuccessBody
                                },
                                color = theme.secondaryText,
                                style = MaterialTheme.typography.bodyMedium
                            )
                        },
                        confirmButton = {
                            TextButton(onClick = { purchaseConfirmation = null }) {
                                Text(strings.ok, color = theme.primaryAccent)
                            }
                        }
                    )
                }
                if (showTransferSuccess) {
                    AlertDialog(
                        onDismissRequest = { showTransferSuccess = false },
                        containerColor = theme.card,
                        title = {
                            Text(
                                text = strings.transferSuccessTitle,
                                color = theme.primaryText,
                                style = MaterialTheme.typography.titleLarge
                            )
                        },
                        text = {
                            Text(
                                text = strings.transferSuccessBody,
                                color = theme.secondaryText,
                                style = MaterialTheme.typography.bodyMedium
                            )
                        },
                        confirmButton = {
                            TextButton(onClick = { showTransferSuccess = false }) {
                                Text(strings.ok, color = theme.primaryAccent)
                            }
                        }
                    )
                }
            }
        }
    }
}

private enum class SettingsSubScreen {
    Main,
    Purchase,
    CreateAgency,
    Notifications,
    ThemeShowcase,
    TransferPlan
}

private enum class PurchaseConfirmationKind {
    Purchase,
    Restore
}

private fun String.isStoreReviewAccountEmail(): Boolean {
    val normalized = trim().lowercase().replace('_', '-')
    return normalized == "appreview85888@appreview-havn.test" ||
        (normalized.startsWith("appreview") && normalized.endsWith("@appreview-havn.test"))
}

private suspend fun AgencyViewModel.syncRevenueCatSubscriptionWithExpectedTier(
    fallbackTier: HavnSubscriptionTier,
    expectedTier: HavnSubscriptionTier
): Result<UserEntitlement> {
    var latest = syncRevenueCatSubscription(fallbackTier)
    if (latest.getOrNull()?.tier.hasAtLeastTier(expectedTier)) return latest

    repeat(3) {
        delay(1_500)
        latest = syncRevenueCatSubscription(fallbackTier)
        if (latest.getOrNull()?.tier.hasAtLeastTier(expectedTier)) return latest
    }
    return if (latest.isFailure) latest else Result.failure(
        HavnPurchasePendingException()
    )
}

private fun HavnSubscriptionTier?.hasAtLeastTier(expectedTier: HavnSubscriptionTier): Boolean =
    subscriptionTierRank(this ?: HavnSubscriptionTier.Free) >= subscriptionTierRank(expectedTier)

private fun maxSubscriptionTier(
    first: HavnSubscriptionTier,
    second: HavnSubscriptionTier
): HavnSubscriptionTier =
    if (subscriptionTierRank(first) >= subscriptionTierRank(second)) first else second

private fun subscriptionTierRank(tier: HavnSubscriptionTier): Int = when (tier) {
    HavnSubscriptionTier.Free -> 0
    HavnSubscriptionTier.SoloAgent -> 1
    HavnSubscriptionTier.ProAgent -> 2
    HavnSubscriptionTier.TeamAgent -> 3
}

private fun purchaseUserMessage(
    error: Throwable,
    strings: HavnStrings,
    kind: PurchaseConfirmationKind
): String {
    if (error is HavnPurchasePendingException) return strings.purchaseVerificationPending
    val message = error.message.orEmpty()
    if (message.contains("cancelled", ignoreCase = true) || message.contains("canceled", ignoreCase = true)) {
        return "Purchase cancelled."
    }
    return when (kind) {
        PurchaseConfirmationKind.Purchase -> strings.purchaseCouldNotComplete
        PurchaseConfirmationKind.Restore -> strings.restoreCouldNotComplete
    }
}

private fun SettingsSubScreen.depth(): Int = when (this) {
    SettingsSubScreen.Main -> 0
    SettingsSubScreen.Purchase,
    SettingsSubScreen.CreateAgency,
    SettingsSubScreen.Notifications,
    SettingsSubScreen.ThemeShowcase,
    SettingsSubScreen.TransferPlan -> 1
}

@Composable
private fun TransferPlanScreen(
    onCreateTransfer: suspend (String) -> Result<SubscriptionTransferRequest>,
    onConfirmTransfer: suspend (String, String, String) -> Result<Unit>,
    onBack: () -> Unit
) {
    val strings = LocalHavnStrings.current
    val theme = LocalHavnThemeTokens.current
    val scope = rememberCoroutineScope()
    var targetEmail by remember { mutableStateOf("") }
    var sourceCode by remember { mutableStateOf("") }
    var targetCode by remember { mutableStateOf("") }
    var transferRequest by remember { mutableStateOf<SubscriptionTransferRequest?>(null) }
    var isSending by remember { mutableStateOf(false) }
    var isConfirming by remember { mutableStateOf(false) }
    var error by remember { mutableStateOf<String?>(null) }

    HavnScreenFrame(
        eyebrow = "",
        title = strings.transferPlanTitle,
        subtitle = "",
        backLabel = strings.settingsTitle,
        onBack = onBack
    ) {
        Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
            HavnCard {
                Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
                    Text(
                        text = strings.transferPlanBody,
                        color = theme.secondaryText,
                        style = MaterialTheme.typography.bodyMedium
                    )
                    HavnTextField(
                        value = targetEmail,
                        onValueChange = {
                            targetEmail = it
                            error = null
                        },
                        label = strings.transferTargetEmail,
                        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Email)
                    )
                    HavnButton(
                        text = strings.transferSendCodes,
                        onClick = {
                            isSending = true
                            error = null
                            scope.launch {
                                onCreateTransfer(targetEmail)
                                    .onSuccess {
                                        transferRequest = it
                                        sourceCode = ""
                                        targetCode = ""
                                    }
                                    .onFailure { error = it.havnFriendlyMessage("Could not start the transfer. Please try again.") }
                                isSending = false
                            }
                        },
                        loading = isSending,
                        enabled = !isSending && targetEmail.isNotBlank(),
                        modifier = Modifier.fillMaxWidth(),
                        expandOnWeb = true
                    )
                }
            }

            transferRequest?.let { request ->
                HavnCard {
                    Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
                        Text(
                            text = strings.transferCodesSentTitle,
                            color = theme.primaryText,
                            style = MaterialTheme.typography.titleLarge
                        )
                        Text(
                            text = strings.transferCodesSentBody,
                            color = theme.secondaryText,
                            style = MaterialTheme.typography.bodyMedium
                        )
                        Text(
                            text = "${request.sourceEmail} -> ${request.targetEmail}",
                            color = theme.mutedText,
                            style = MaterialTheme.typography.labelLarge
                        )
                        HavnTextField(
                            value = sourceCode,
                            onValueChange = {
                                if (it.length <= 8) sourceCode = it.filter(Char::isDigit)
                                error = null
                            },
                            label = strings.transferYourCode,
                            keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number)
                        )
                        HavnTextField(
                            value = targetCode,
                            onValueChange = {
                                if (it.length <= 8) targetCode = it.filter(Char::isDigit)
                                error = null
                            },
                            label = strings.transferTargetCode,
                            keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number)
                        )
                        HavnButton(
                            text = strings.transferConfirm,
                            onClick = {
                                isConfirming = true
                                error = null
                                scope.launch {
                                    onConfirmTransfer(request.id, sourceCode, targetCode)
                                        .onFailure { error = it.havnFriendlyMessage("Could not confirm the transfer. Please try again.") }
                                    isConfirming = false
                                }
                            },
                            loading = isConfirming,
                            enabled = !isConfirming && sourceCode.length >= 4 && targetCode.length >= 4,
                            modifier = Modifier.fillMaxWidth(),
                            expandOnWeb = true
                        )
                    }
                }
            }

            error?.let {
                Text(text = it, color = HavnDanger, style = MaterialTheme.typography.labelLarge)
            }
        }
    }
}

@Composable
private fun NotificationsSettingsScreen(
    preferences: HavnNotificationPreferences,
    error: String?,
    onPreferenceChanged: (HavnNotificationType, Boolean) -> Unit,
    onQuietHoursChanged: (HavnNotificationSettings) -> Unit,
    onBack: () -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    val strings = LocalHavnStrings.current
    HavnScreenFrame(
        eyebrow = "",
        title = strings.notificationsTitle,
        subtitle = strings.notificationsSubtitle,
        backLabel = strings.commonSettings,
        onBack = onBack
    ) {
        Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
            HavnCard {
                Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
                    Text(strings.quietHoursTitle, color = theme.primaryText, style = MaterialTheme.typography.titleLarge)
                    Text(
                        strings.quietHoursBody,
                        color = theme.secondaryText,
                        style = MaterialTheme.typography.bodyMedium
                    )
                    SettingSwitchRow(
                        title = strings.enableQuietHours,
                        body = "${preferences.settings.quietHoursStart} to ${preferences.settings.quietHoursEnd}",
                        checked = preferences.settings.quietHoursEnabled,
                        onCheckedChange = {
                            onQuietHoursChanged(preferences.settings.copy(quietHoursEnabled = it))
                        }
                    )
                    Row(horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm)) {
                        HavnTextField(
                            value = preferences.settings.quietHoursStart,
                            onValueChange = { value ->
                                if (value.length <= 5) onQuietHoursChanged(preferences.settings.copy(quietHoursStart = normalizeTimeInput(value)))
                            },
                            label = strings.quietHoursStart,
                            keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
                            modifier = Modifier.weight(1f)
                        )
                        HavnTextField(
                            value = preferences.settings.quietHoursEnd,
                            onValueChange = { value ->
                                if (value.length <= 5) onQuietHoursChanged(preferences.settings.copy(quietHoursEnd = normalizeTimeInput(value)))
                            },
                            label = strings.quietHoursEnd,
                            keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
                            modifier = Modifier.weight(1f)
                        )
                    }
                    Text("${strings.timezoneLabel}: ${preferences.settings.timezone}", color = theme.mutedText, style = MaterialTheme.typography.labelMedium)
                }
            }

            HavnCard {
                Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.sm)) {
                    Text(strings.notificationTypesTitle, color = theme.primaryText, style = MaterialTheme.typography.titleLarge)
                    HavnNotificationType.entries.forEach { type ->
                        SettingSwitchRow(
                            title = type.localizedTitle(strings),
                            body = type.localizedDescription(strings),
                            checked = preferences.enabled(type),
                            onCheckedChange = { enabled -> onPreferenceChanged(type, enabled) }
                        )
                    }
                }
            }
            error?.let {
                Text(text = it, color = HavnDanger, style = MaterialTheme.typography.labelLarge)
            }
        }
    }
}

@Composable
private fun SettingSwitchRow(
    title: String,
    body: String,
    checked: Boolean,
    onCheckedChange: (Boolean) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    Row(
        modifier = Modifier.fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(HavnSpacing.md)
    ) {
        Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(3.dp)) {
            Text(title, color = theme.primaryText, style = MaterialTheme.typography.bodyLarge)
            Text(body, color = theme.secondaryText, style = MaterialTheme.typography.bodySmall)
        }
        Switch(checked = checked, onCheckedChange = onCheckedChange)
    }
}

private fun normalizeTimeInput(value: String): String {
    val digits = value.filter { it.isDigit() }.take(4)
    if (digits.length <= 2) return digits
    return "${digits.take(2)}:${digits.drop(2)}"
}

@Composable
private fun McpApiKeyCard(
    keys: List<McpApiKey>,
    revealedKey: String?,
    keyVisible: Boolean,
    copied: Boolean,
    loading: Boolean,
    rotating: Boolean,
    canUseMcp: Boolean,
    error: String?,
    onRevealChanged: (Boolean) -> Unit,
    onCopy: (String) -> Unit,
    onRotate: () -> Unit,
    onRevoke: (McpApiKey) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    val strings = LocalHavnStrings.current
    val activeKey = keys.firstOrNull { it.isActive }
    val displayKey = when {
        revealedKey != null && keyVisible -> revealedKey
        revealedKey != null -> maskMcpKey(revealedKey)
        activeKey != null -> "${activeKey.keyPrefix}..."
        else -> strings.mcpNoApiKeyCreated
    }

    HavnCard {
        Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm)
            ) {
                HavnIcon(
                    icon = HavnIconKey.QrCode,
                    contentDescription = null,
                    tint = theme.primaryAccent,
                    modifier = Modifier.size(22.dp)
                )
                Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(2.dp)) {
                    Text(strings.mcpAccessTitle, color = theme.primaryText, style = MaterialTheme.typography.titleLarge)
                    Text(
                        strings.mcpAccessBody,
                        color = theme.secondaryText,
                        style = MaterialTheme.typography.bodyMedium
                    )
                }
            }

            Surface(
                modifier = Modifier.fillMaxWidth(),
                shape = MaterialTheme.shapes.medium,
                color = theme.surface,
                border = BorderStroke(1.dp, theme.border)
            ) {
                Column(
                    modifier = Modifier.padding(HavnSpacing.md),
                    verticalArrangement = Arrangement.spacedBy(HavnSpacing.sm)
                ) {
                    Text(strings.mcpAuthorizationBearer, color = theme.mutedText, style = MaterialTheme.typography.labelLarge)
                    Text(
                        text = displayKey,
                        color = theme.primaryText,
                        style = MaterialTheme.typography.bodyMedium,
                        maxLines = 2,
                        overflow = TextOverflow.Ellipsis
                    )
                    activeKey?.let {
                        val used = it.lastUsedAt?.takeIf(String::isNotBlank)
                            ?.let { value -> "${strings.mcpLastUsedPrefix} $value" }
                            ?: strings.mcpNotUsedYet
                        Text(used, color = theme.mutedText, style = MaterialTheme.typography.bodySmall)
                    }
                }
            }

            if (revealedKey != null) {
                SettingSwitchRow(
                    title = strings.mcpRevealApiKeyTitle,
                    body = strings.mcpRevealApiKeyBody,
                    checked = keyVisible,
                    onCheckedChange = onRevealChanged
                )
            }

            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm)
            ) {
                HavnButton(
                    text = when {
                        loading -> strings.mcpLoading
                        activeKey == null -> strings.mcpCreateKey
                        else -> strings.mcpRotateKey
                    },
                    onClick = onRotate,
                    loading = rotating || loading,
                    enabled = canUseMcp && !rotating && !loading,
                    modifier = Modifier.weight(1f),
                    style = HavnButtonStyle.Secondary,
                    leadingIcon = HavnIconKey.Plus
                )
                HavnButton(
                    text = if (copied) strings.mcpCopied else strings.mcpCopy,
                    onClick = { revealedKey?.let(onCopy) },
                    enabled = canUseMcp && revealedKey != null && !rotating,
                    modifier = Modifier.weight(1f),
                    style = HavnButtonStyle.Secondary,
                    leadingIcon = HavnIconKey.Note
                )
            }

            activeKey?.let { key ->
                HavnButton(
                    text = strings.mcpRevokeKey,
                    onClick = { onRevoke(key) },
                    enabled = !rotating,
                    modifier = Modifier.fillMaxWidth(),
                    style = HavnButtonStyle.Danger,
                    leadingIcon = HavnIconKey.Trash
                )
            }

            Text(
                if (canUseMcp) {
                    strings.mcpEndpointHint
                } else {
                    strings.mcpUpgradeHint
                },
                color = theme.mutedText,
                style = MaterialTheme.typography.bodySmall
            )
            error?.let {
                Text(text = it, color = HavnDanger, style = MaterialTheme.typography.labelLarge)
            }
        }
    }
}

private fun maskMcpKey(value: String): String {
    if (value.length <= 20) return "••••"
    return "${value.take(14)}••••••••${value.takeLast(4)}"
}

private fun HavnNotificationType.localizedTitle(strings: com.havn.app.core.localization.HavnStrings): String = when (this) {
    HavnNotificationType.NewLeadCaptured -> strings.notificationNewLeadCapturedTitle
    HavnNotificationType.VisitorMarkedHotLead -> strings.notificationHotLeadTitle
    HavnNotificationType.OpenHouseStartsSoon -> strings.notificationOpeningStartsSoonTitle
    HavnNotificationType.OpenHouseSummaryReady -> strings.notificationOpeningSummaryReadyTitle
    HavnNotificationType.SellerReportGenerated -> strings.notificationSellerReportGeneratedTitle
    HavnNotificationType.AiFollowUpReady -> strings.notificationAiFollowUpReadyTitle
    HavnNotificationType.AgentInvitedToAgency -> strings.notificationAgentInvitedTitle
    HavnNotificationType.LeadAssigned -> strings.notificationLeadAssignedTitle
    HavnNotificationType.LeadTransferred -> strings.notificationLeadTransferredTitle
    HavnNotificationType.SubscriptionIssue -> strings.notificationSubscriptionIssueTitle
}

private fun HavnNotificationType.localizedDescription(strings: com.havn.app.core.localization.HavnStrings): String = when (this) {
    HavnNotificationType.NewLeadCaptured -> strings.notificationNewLeadCapturedBody
    HavnNotificationType.VisitorMarkedHotLead -> strings.notificationHotLeadBody
    HavnNotificationType.OpenHouseStartsSoon -> strings.notificationOpeningStartsSoonBody
    HavnNotificationType.OpenHouseSummaryReady -> strings.notificationOpeningSummaryReadyBody
    HavnNotificationType.SellerReportGenerated -> strings.notificationSellerReportGeneratedBody
    HavnNotificationType.AiFollowUpReady -> strings.notificationAiFollowUpReadyBody
    HavnNotificationType.AgentInvitedToAgency -> strings.notificationAgentInvitedBody
    HavnNotificationType.LeadAssigned -> strings.notificationLeadAssignedBody
    HavnNotificationType.LeadTransferred -> strings.notificationLeadTransferredBody
    HavnNotificationType.SubscriptionIssue -> strings.notificationSubscriptionIssueBody
}

@Composable
private fun AppearanceCard(
    selectedTheme: HavnThemeType,
    onThemeSelected: (HavnThemeType) -> Unit,
    onPreview: () -> Unit
) {
    val strings = LocalHavnStrings.current
    val theme = LocalHavnThemeTokens.current
    val buttonModifier = Modifier.fillMaxWidth()
    HavnCard {
        Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
            Text(strings.appearanceTitle, color = theme.primaryText, style = MaterialTheme.typography.titleLarge)
            Text(
                strings.appearanceBody,
                color = theme.secondaryText,
                style = MaterialTheme.typography.bodyMedium
            )
            listOf(HavnThemeType.OBSIDIAN_GOLD, HavnThemeType.LIGHT).forEach { themeType ->
                ThemeOptionCard(
                    themeType = themeType,
                    selected = selectedTheme == themeType,
                    locked = false,
                    onClick = { onThemeSelected(themeType) }
                )
            }
            HavnButton(
                text = strings.previewComponents,
                onClick = onPreview,
                style = HavnButtonStyle.Secondary,
                modifier = buttonModifier
            )
        }
    }
}

@Composable
private fun ThemeOptionCard(
    themeType: HavnThemeType,
    selected: Boolean,
    locked: Boolean,
    onClick: () -> Unit
) {
    val strings = LocalHavnStrings.current
    val theme = HavnThemeCatalog.tokensFor(themeType)
    Surface(
        modifier = Modifier
            .fillMaxWidth()
            .clip(MaterialTheme.shapes.medium)
            .clickable(onClick = onClick),
        shape = MaterialTheme.shapes.medium,
        color = if (selected) theme.primaryAccent.copy(alpha = 0.14f) else LocalHavnThemeTokens.current.card,
        border = BorderStroke(1.dp, if (selected) theme.primaryAccent else LocalHavnThemeTokens.current.border)
    ) {
        Row(
            modifier = Modifier.padding(HavnSpacing.md),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(HavnSpacing.md)
        ) {
            ThemePreviewDots(theme)
            Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(3.dp)) {
                Text(themeType.localizedName(strings), color = LocalHavnThemeTokens.current.primaryText, style = MaterialTheme.typography.titleMedium)
                Text(
                    if (locked) "${themeType.localizedDescription(strings)} ${strings.proAgentPlan}" else themeType.localizedDescription(strings),
                    color = LocalHavnThemeTokens.current.secondaryText,
                    style = MaterialTheme.typography.bodySmall,
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis
                )
            }
            HavnIcon(
                icon = if (selected) HavnIconKey.Check else HavnIconKey.Star,
                contentDescription = null,
                tint = if (selected) theme.primaryAccent else LocalHavnThemeTokens.current.mutedText,
                modifier = Modifier.size(20.dp)
            )
        }
    }
}

@Composable
private fun ThemePreviewDots(theme: HavnThemeTokens) {
    Row(horizontalArrangement = Arrangement.spacedBy(5.dp)) {
        listOf(theme.background, theme.card, theme.primaryAccent, theme.secondaryAccent).forEach { color ->
            Surface(
                modifier = Modifier.size(14.dp),
                shape = CircleShape,
                color = color,
                border = BorderStroke(1.dp, theme.border)
            ) {}
        }
    }
}

@Composable
private fun ThemeShowcaseScreen(onBack: () -> Unit) {
    val strings = LocalHavnStrings.current
    HavnScreenFrame(
        eyebrow = strings.appearanceTitle,
        title = strings.themeShowcaseTitle,
        subtitle = "",
        backLabel = strings.settingsTitle,
        onBack = onBack
    ) {
        Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
            HavnCard {
                Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.sm)) {
                    Text(strings.showcaseButtons, color = LocalHavnThemeTokens.current.primaryText, style = MaterialTheme.typography.titleLarge)
                    HavnButton(strings.showcasePrimaryAction, onClick = {}, modifier = Modifier.fillMaxWidth())
                    HavnButton(strings.showcaseSecondaryAction, onClick = {}, style = HavnButtonStyle.Secondary, modifier = Modifier.fillMaxWidth())
                    HavnButton(strings.showcaseGhostAction, onClick = {}, style = HavnButtonStyle.Ghost, modifier = Modifier.fillMaxWidth())
                }
            }

            HavnTextField(value = "", onValueChange = {}, label = strings.showcaseTextField, placeholder = strings.showcaseFocusedBorder)
            HavnSearchField(value = "", onValueChange = {}, placeholder = strings.showcaseSearchPreview)

            Row(horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm)) {
                HavnStatCard("12", strings.navLeads, modifier = Modifier.weight(1f), icon = HavnIconKey.Leads)
                HavnStatCard("4", strings.navOpenHouses, modifier = Modifier.weight(1f), trend = "+2")
            }

            Row(horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm)) {
                HavnStatusBadge(HavnStatus.Active)
                HavnStatusBadge(HavnStatus.Warm)
                HavnStatusBadge(HavnStatus.Cold)
            }

            HavnPropertyCard(
                address = "123 Maple Drive",
                city = "Miami Beach, FL",
                status = HavnStatus.Active,
                visitorCount = 24,
                hotLeadCount = 6,
                nextOpenHouseTime = "Today, 4:00 PM",
                price = "$2.49M"
            )
            HavnLeadCard(
                name = "Sophia Martinez",
                contact = "123 Maple Drive",
                sourceProperty = strings.showcaseOpeningCheckedIn,
                temperature = HavnStatus.Hot,
                lastActivityTime = strings.showcaseSentAt
            )
        }
    }
}

@Composable
private fun CreateAgencyScreen(
    state: AgencyUiState,
    onAgencyNameChanged: (String) -> Unit,
    onCreateAgency: () -> Unit,
    onDismissError: () -> Unit,
    onBack: () -> Unit
) {
    var agencyEmail by remember { mutableStateOf("") }
    val strings = LocalHavnStrings.current
    val theme = LocalHavnThemeTokens.current
    val buttonModifier = Modifier.fillMaxWidth()

    LaunchedEffect(state.hasOwnedAgency, state.isSaving) {
        if (state.hasOwnedAgency && !state.isSaving) {
            onBack()
        }
    }

    HavnScreenFrame(
        eyebrow = "",
        title = strings.createAgency,
        subtitle = "",
        backLabel = strings.commonAgency,
        onBack = onBack
    ) {
        Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
            HavnCard {
                Column(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.spacedBy(HavnSpacing.sm)
                ) {
                    Surface(
                        modifier = Modifier.size(72.dp),
                        shape = CircleShape,
                        color = theme.primaryAccent.copy(alpha = 0.12f),
                        border = BorderStroke(1.dp, theme.primaryAccent)
                    ) {
                        Box(contentAlignment = Alignment.Center) {
                            HavnIcon(
                                icon = HavnIconKey.Users,
                                contentDescription = null,
                                tint = theme.primaryAccent,
                                modifier = Modifier.size(34.dp)
                            )
                        }
                    }
                    Text(
                        text = strings.createYourAgency,
                        color = theme.primaryText,
                        style = MaterialTheme.typography.titleLarge
                    )
                    Text(
                        text = strings.createAgencyBody,
                        color = theme.secondaryText,
                        style = MaterialTheme.typography.bodyMedium,
                        textAlign = androidx.compose.ui.text.style.TextAlign.Center
                    )
                }
            }

            HavnCard {
                Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
                    HavnTextField(
                        value = state.newAgencyName,
                        onValueChange = onAgencyNameChanged,
                        label = strings.agencyName,
                        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Text)
                    )
                    HavnTextField(
                        value = agencyEmail,
                        onValueChange = { agencyEmail = it },
                        label = strings.agencyEmail,
                        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Email)
                    )
                    Text(
                        text = strings.logoOptional,
                        color = theme.mutedText,
                        style = MaterialTheme.typography.labelLarge
                    )
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(HavnSpacing.md)
                    ) {
                        Surface(
                            modifier = Modifier.size(72.dp),
                            shape = MaterialTheme.shapes.medium,
                            color = theme.background,
                            border = BorderStroke(1.dp, theme.primaryAccent.copy(alpha = 0.72f))
                        ) {
                            Box(contentAlignment = Alignment.Center) {
                                Text(
                                    text = state.newAgencyName
                                        .split(" ")
                                        .mapNotNull { it.firstOrNull()?.uppercase() }
                                        .take(2)
                                        .joinToString("")
                                        .ifBlank { "A" },
                                    color = theme.primaryAccent,
                                    style = MaterialTheme.typography.titleLarge
                                )
                            }
                        }
                        HavnButton(
                            text = strings.commonChange,
                            onClick = { },
                            style = HavnButtonStyle.Secondary
                        )
                    }
                    HavnButton(
                        text = strings.createAgency,
                        onClick = onCreateAgency,
                        loading = state.isSaving,
                        enabled = !state.isSaving,
                        modifier = buttonModifier
                    )
                }
            }

            state.error?.let { error ->
                HavnCard {
                    Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.sm)) {
                        Text(error, color = theme.danger, style = MaterialTheme.typography.bodyMedium)
                        HavnButton(
                            text = strings.commonDismiss,
                            onClick = onDismissError,
                            style = HavnButtonStyle.Ghost,
                            modifier = buttonModifier
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun AgentPlanCard(
    planName: String,
    canTransferPlan: Boolean,
    onUpgradePlan: () -> Unit,
    onTransferPlan: () -> Unit,
    onRestorePurchase: () -> Unit
) {
    val strings = LocalHavnStrings.current
    val theme = LocalHavnThemeTokens.current
    val buttonModifier = Modifier.fillMaxWidth()
    HavnCard {
        Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
            Text(
                text = strings.agentPlanTitle,
                color = theme.primaryText,
                style = MaterialTheme.typography.titleLarge
            )
            Text(
                text = strings.agentPlanBody,
                color = theme.secondaryText,
                style = MaterialTheme.typography.bodyMedium
            )
            WorkspaceOptionRow(
                title = planName,
                body = strings.currentPlan,
                selected = true,
                enabled = false,
                onClick = {}
            )
            HavnButton(
                text = strings.upgradePlan,
                onClick = onUpgradePlan,
                modifier = buttonModifier
            )
            if (canTransferPlan) {
                HavnButton(
                    text = strings.transferPlan,
                    onClick = onTransferPlan,
                    style = HavnButtonStyle.Secondary,
                    modifier = buttonModifier
                )
            }
            HavnButton(
                text = strings.restorePurchase,
                onClick = onRestorePurchase,
                style = HavnButtonStyle.Ghost,
                modifier = buttonModifier
            )
        }
    }
}

@Composable
private fun AgencySettingsCard(
    state: AgencyUiState,
    onSelectSolo: () -> Unit,
    onSelectAgency: (String) -> Unit,
    onCreateAgencyRequested: () -> Unit,
    onPurchaseRequired: () -> Unit,
    onDismissError: () -> Unit
) {
    val strings = LocalHavnStrings.current
    val canUseAgency = state.entitlement.isProAgent
    val theme = LocalHavnThemeTokens.current
    val buttonModifier = Modifier.fillMaxWidth()
    HavnCard {
        Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
            Text(
                text = strings.commonAgency,
                color = theme.primaryText,
                style = MaterialTheme.typography.titleLarge
            )
            Text(
                text = if (canUseAgency) {
                    strings.agencySettingsProBody
                } else {
                    strings.agencySettingsLockedBody
                },
                color = theme.secondaryText,
                style = MaterialTheme.typography.bodyMedium
            )

            WorkspaceOptionRow(
                title = strings.soloAgency,
                body = strings.defaultPrivateAgencyWorkspace,
                selected = state.selectedAgencyId == null,
                enabled = true,
                onClick = onSelectSolo
            )

            state.agencies.forEach { agency ->
                AgencyOptionRow(
                    agency = agency,
                    selected = state.selectedAgencyId == agency.id,
                    enabled = true,
                    canUseAgency = canUseAgency,
                    onClick = {
                        if (canUseAgency) onSelectAgency(agency.id) else onPurchaseRequired()
                    }
                )
            }

            if (state.agencies.isEmpty() && canUseAgency && !state.entitlement.canCreateAgency) {
                Text(
                    text = strings.noAgenciesAvailableYet,
                    color = theme.mutedText,
                    style = MaterialTheme.typography.bodyMedium
                )
            }

            if (state.hasOwnedAgency) {
                Text(
                    text = strings.oneOwnedAgencyHint,
                    color = theme.mutedText,
                    style = MaterialTheme.typography.bodyMedium
                )
            } else {
                HavnButton(
                    text = strings.createAgency,
                    onClick = {
                        if (!canUseAgency) {
                            onPurchaseRequired()
                        } else {
                            onCreateAgencyRequested()
                        }
                    },
                    loading = state.isSaving,
                    enabled = !state.isSaving,
                    modifier = buttonModifier
                )
            }

            state.error?.let { error ->
                Text(
                    text = error,
                    color = HavnDanger,
                    style = MaterialTheme.typography.labelLarge
                )
                HavnButton(
                    text = strings.commonDismiss,
                    onClick = onDismissError,
                    modifier = buttonModifier
                )
            }
        }
    }
}

@Composable
private fun PurchaseScreen(
    billingService: HavnBillingService,
    userId: String?,
    backLabel: String,
    onPurchaseCompleted: suspend (HavnBillingCustomerState, PurchaseConfirmationKind, HavnSubscriptionTier) -> Result<Unit>,
    onBack: () -> Unit
) {
    val strings = LocalHavnStrings.current
    val theme = LocalHavnThemeTokens.current
    val scope = rememberCoroutineScope()
    var selectedPlan by remember { mutableStateOf(HavnSubscriptionTier.ProAgent.databaseValue) }
    var selectedPeriod by remember { mutableStateOf(HavnBillingPeriod.Monthly) }
    var storePlans by remember { mutableStateOf(HavnStorePlans()) }
    var purchaseError by remember { mutableStateOf<String?>(null) }
    var isLoadingProducts by remember { mutableStateOf(false) }
    var isPurchasing by remember { mutableStateOf(false) }
    var isRestoring by remember { mutableStateOf(false) }
    var comparePlans by remember { mutableStateOf(false) }

    LaunchedEffect(userId) {
        val currentUserId = userId ?: return@LaunchedEffect
        isLoadingProducts = true
        billingService.loadPlans(currentUserId)
            .onSuccess {
                storePlans = it
                purchaseError = null
            }
            .onFailure { purchaseError = it.message }
        isLoadingProducts = false
    }

    fun selectedTier(): HavnSubscriptionTier = HavnSubscriptionTier.fromDatabase(selectedPlan)

    fun selectedOption(): HavnStorePlanOption? {
        return storePlans.option(selectedTier(), selectedPeriod)
    }

    fun priceFor(tier: HavnSubscriptionTier): String {
        return launchPlanPrice(tier, selectedPeriod)
    }

    fun priceLabel(tier: HavnSubscriptionTier): String {
        val periodLabel = if (selectedPeriod == HavnBillingPeriod.Monthly) strings.perMonth else strings.perYear
        return "${priceFor(tier)} $periodLabel"
    }

    val defaultPurchaseTiers = listOf(
        HavnSubscriptionTier.TeamAgent,
        HavnSubscriptionTier.ProAgent,
        HavnSubscriptionTier.SoloAgent
    )
    val purchasableTiers = defaultPurchaseTiers.filter { tier ->
        storePlans.option(tier, selectedPeriod) != null
    }
    val visiblePurchaseTiers = if (isLoadingProducts || storePlans.options.isEmpty()) {
        defaultPurchaseTiers
    } else {
        purchasableTiers
    }

    LaunchedEffect(storePlans, selectedPeriod) {
        if (purchasableTiers.isNotEmpty() && selectedOption() == null) {
            selectedPlan = purchasableTiers.first().databaseValue
        }
    }

    fun yearlyCaption(tier: HavnSubscriptionTier): String? {
        if (selectedPeriod != HavnBillingPeriod.Yearly) return null
        val effectiveMonthlyPrice = effectiveMonthlyPriceLabel(priceFor(tier))
        return if (effectiveMonthlyPrice != null) {
            "$effectiveMonthlyPrice ${strings.perMonth}. Save 2 months with yearly plan."
        } else {
            "Save 2 months with yearly plan."
        }
    }

    fun planHighlights(tier: HavnSubscriptionTier): List<String> {
        val limits = HavnPlans.limitsFor(tier)
        val storage = formatPlanBytes(limits.documentsStorageBytes)
        return when (tier) {
            HavnSubscriptionTier.Free -> listOf(
                "Run your first Open House free",
                "Kiosk Mode, QR sign-in, and lead capture",
                "${formatPlanNumber(limits.maxProperties)} property, ${formatPlanNumber(limits.maxOpenings)} open houses, ${formatPlanNumber(limits.maxLeads)} leads",
                "Basic follow-up workflow"
            )
            HavnSubscriptionTier.SoloAgent -> listOf(
                "Kiosk Mode and agent workspace",
                "Up to ${formatPlanNumber(limits.maxOpenings)} open houses and ${formatPlanNumber(limits.maxLeads)} leads",
                "AI text generation, ${formatPlanNumber(limits.aiTextGenerationRequestsPerMonth)} requests / month",
                "$storage document storage"
            )
            HavnSubscriptionTier.ProAgent -> listOf(
                "Agency agenda, tasks, and collaboration",
                "Seller reports and analytics",
                "Up to ${formatPlanNumber(limits.maxOpenings)} open houses and ${formatPlanNumber(limits.maxLeads)} leads",
                "$storage document storage"
            )
            HavnSubscriptionTier.TeamAgent -> listOf(
                "Team workspace for brokerages",
                "Shared agency operations at scale",
                "Priority email support and daily backups",
                "${formatPlanNumber(limits.maxOpenings)} open houses, ${formatPlanNumber(limits.maxLeads)} leads, $storage storage"
            )
        }
    }

    HavnPushNavigation(
        targetState = comparePlans,
        depthFor = { compareVisible -> if (compareVisible) 1 else 0 },
        modifier = Modifier.fillMaxSize()
    ) { compareVisible ->
        if (compareVisible) {
            ComparePlansScreen(
                selectedPlan = selectedPlan,
                selectedPeriod = selectedPeriod,
                storePlans = storePlans,
                onSelectPlan = { selectedPlan = it },
                onBack = { comparePlans = false }
            )
        } else {
            HavnScreenFrame(
                eyebrow = "",
                title = strings.upgradeExperienceTitle,
                subtitle = strings.upgradeExperienceSubtitle,
                backLabel = backLabel,
                onBack = onBack
            ) {
                Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
                    BillingPeriodSegmentedControl(
                        selectedPeriod = selectedPeriod,
                        onPeriodSelected = { selectedPeriod = it }
                    )
                    visiblePurchaseTiers.forEach { tier ->
                        PlanCard(
                            title = planTitle(tier, strings),
                            price = priceLabel(tier),
                            caption = yearlyCaption(tier),
                            icon = planIcon(tier),
                            selected = selectedTier() == tier,
                            onClick = { selectedPlan = tier.databaseValue },
                            benefits = planHighlights(tier)
                        )
                    }
                    if (!isLoadingProducts && purchasableTiers.isEmpty()) {
                        Text(
                            text = strings.selectedPlanUnavailable,
                            color = theme.secondaryText,
                            style = MaterialTheme.typography.bodyMedium
                        )
                    }
                    HavnButton(
                        text = if (isLoadingProducts) strings.loadingPlans else strings.startFreeTrial7Day,
                        onClick = {
                            val currentUserId = userId
                            val option = selectedOption()
                            if (currentUserId == null) {
                                purchaseError = strings.signInRequiredForPurchase
                            } else if (option == null) {
                                purchaseError = strings.selectedPlanUnavailable
                            } else {
                                isPurchasing = true
                                purchaseError = null
                                scope.launch {
                                    billingService.purchase(option, currentUserId)
                                        .onSuccess { customerState ->
                                            if (customerState.hasActiveHavnSubscription) {
                                                onPurchaseCompleted(customerState, PurchaseConfirmationKind.Purchase, option.tier)
                                                    .onFailure { purchaseError = purchaseUserMessage(it, strings, PurchaseConfirmationKind.Purchase) }
                                            } else if (!havnIsWebShell) {
                                                purchaseError = strings.noActiveSubscriptionFound
                                            }
                                        }
                                        .onFailure { purchaseError = purchaseUserMessage(it, strings, PurchaseConfirmationKind.Purchase) }
                                    isPurchasing = false
                                }
                            }
                        },
                        modifier = Modifier.fillMaxWidth(),
                        enabled = !isLoadingProducts && !isPurchasing && selectedOption() != null,
                        loading = isPurchasing,
                        expandOnWeb = true
                    )
                    if (isPurchasing && havnIsWebShell) {
                        Text(
                            text = strings.completeWebCheckout,
                            color = theme.secondaryText,
                            style = MaterialTheme.typography.bodyMedium
                        )
                    }
                    purchaseError?.let {
                        Text(text = it, color = HavnDanger, style = MaterialTheme.typography.labelLarge)
                    }
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm)
                    ) {
                        HavnButton(
                            text = strings.restorePurchase,
                            onClick = {
                                val currentUserId = userId
                                if (currentUserId == null) {
                                    purchaseError = strings.signInRequiredForPurchase
                                } else {
                                    isRestoring = true
                                    purchaseError = null
                                    scope.launch {
                                        billingService.restorePurchases(currentUserId)
                                            .onSuccess { customerState ->
                                                if (customerState.hasActiveHavnSubscription) {
                                                    onPurchaseCompleted(customerState, PurchaseConfirmationKind.Restore, customerState.tier)
                                                        .onFailure { purchaseError = purchaseUserMessage(it, strings, PurchaseConfirmationKind.Restore) }
                                                } else {
                                                    purchaseError = strings.noActiveSubscriptionFound
                                                }
                                            }
                                            .onFailure { purchaseError = purchaseUserMessage(it, strings, PurchaseConfirmationKind.Restore) }
                                        isRestoring = false
                                    }
                                }
                            },
                            modifier = Modifier.weight(1f),
                            style = HavnButtonStyle.Secondary,
                            enabled = !isRestoring,
                            loading = isRestoring,
                            expandOnWeb = true
                        )
                        HavnButton(
                            text = strings.comparePlans,
                            onClick = { comparePlans = true },
                            modifier = Modifier.weight(1f),
                            style = HavnButtonStyle.Secondary,
                            expandOnWeb = true
                        )
                    }
                    SubscriptionDisclosure()
                }
            }
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun SubscriptionDisclosure() {
    val theme = LocalHavnThemeTokens.current
    val strings = LocalHavnStrings.current
    val language = LocalHavnLanguage.current
    val disclosure = SubscriptionDisclosureContent.forPlatform(havnSubscriptionDisclosurePlatform(), strings, language)
    Column(verticalArrangement = Arrangement.spacedBy(8.dp), modifier = Modifier.fillMaxWidth()) {
        Text(
            text = disclosure.body,
            color = theme.secondaryText,
            style = MaterialTheme.typography.bodySmall
        )
        FlowRow(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(4.dp)
        ) {
            Text(
                text = strings.subscriptionAgreementPrefix,
                color = theme.secondaryText,
                style = MaterialTheme.typography.bodySmall
            )
            Text(
                text = strings.subscriptionTermsOfUse,
                color = theme.primaryAccent,
                style = MaterialTheme.typography.bodySmall,
                modifier = Modifier.clickable { HavnExternalActions.openUrl(disclosure.termsUrl) }
            )
            Text(
                text = strings.subscriptionAgreementAnd,
                color = theme.secondaryText,
                style = MaterialTheme.typography.bodySmall
            )
            Text(
                text = strings.subscriptionPrivacyPolicy,
                color = theme.primaryAccent,
                style = MaterialTheme.typography.bodySmall,
                modifier = Modifier.clickable { HavnExternalActions.openUrl(disclosure.privacyUrl) }
            )
        }
    }
}

private data class SubscriptionDisclosureContent(
    val body: String,
    val termsUrl: String,
    val privacyUrl: String
) {
    companion object {
        fun forPlatform(
            platform: HavnSubscriptionDisclosurePlatform,
            strings: HavnStrings,
            language: HavnLanguage
        ): SubscriptionDisclosureContent = when (platform) {
            HavnSubscriptionDisclosurePlatform.Ios -> SubscriptionDisclosureContent(
                body = strings.subscriptionDisclosureIos,
                privacyUrl = legalUrl(language, "apple-privacy-policy"),
                termsUrl = legalUrl(language, "apple-terms-of-use")
            )
            HavnSubscriptionDisclosurePlatform.Android -> SubscriptionDisclosureContent(
                body = strings.subscriptionDisclosureAndroid,
                privacyUrl = legalUrl(language, "google-play-privacy-policy"),
                termsUrl = legalUrl(language, "google-play-terms-of-use")
            )
            HavnSubscriptionDisclosurePlatform.Web -> SubscriptionDisclosureContent(
                body = strings.subscriptionDisclosureWeb,
                privacyUrl = legalUrl(language, "web-privacy-policy"),
                termsUrl = legalUrl(language, "web-terms-of-use")
            )
        }

        private fun legalUrl(language: HavnLanguage, slug: String): String =
            if (language == HavnLanguage.English) {
                "https://havnre.app/$slug"
            } else {
                "https://havnre.app/${language.code}/$slug"
            }
    }
}

@Composable
private fun ComparePlansScreen(
    selectedPlan: String,
    selectedPeriod: HavnBillingPeriod,
    storePlans: HavnStorePlans,
    onSelectPlan: (String) -> Unit,
    onBack: () -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    val strings = LocalHavnStrings.current
    val buttonModifier = Modifier.fillMaxWidth()
    HavnScreenFrame(
        eyebrow = "",
        title = strings.comparePlans,
        subtitle = "",
        backLabel = strings.upgrade,
        onBack = onBack
    ) {
        Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
            PlanComparisonTable(
                selectedPlan = selectedPlan,
                selectedPeriod = selectedPeriod,
                storePlans = storePlans,
                onSelectPlan = onSelectPlan
            )
            HavnButton(
                text = strings.startFreeTrial,
                onClick = { },
                modifier = buttonModifier
            )
            Text(
                text = strings.noCommitmentCancelAnytime,
                modifier = Modifier.fillMaxWidth(),
                color = theme.mutedText,
                style = MaterialTheme.typography.bodyMedium,
                textAlign = androidx.compose.ui.text.style.TextAlign.Center
            )
        }
    }
}

@Composable
private fun PlanComparisonTable(
    selectedPlan: String,
    selectedPeriod: HavnBillingPeriod,
    storePlans: HavnStorePlans,
    onSelectPlan: (String) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    val strings = LocalHavnStrings.current
    val tiers = listOf(
        HavnSubscriptionTier.Free,
        HavnSubscriptionTier.TeamAgent,
        HavnSubscriptionTier.ProAgent,
        HavnSubscriptionTier.SoloAgent
    )
    fun planName(tier: HavnSubscriptionTier): String = when (tier) {
        HavnSubscriptionTier.Free -> strings.compareFreePlan
        HavnSubscriptionTier.SoloAgent -> strings.soloAgentPlan
        HavnSubscriptionTier.ProAgent -> strings.proAgentPlan
        HavnSubscriptionTier.TeamAgent -> strings.teamAgentPlan
    }
    fun price(tier: HavnSubscriptionTier): String =
        launchPlanPrice(tier, selectedPeriod)
    fun whole(value: Int): String = formatPlanNumber(value)
    fun bytes(value: Long): String = formatPlanBytes(value)
    fun yesNo(value: Boolean): String = if (value) strings.compareValueYes else strings.compareValueNo
    fun valueFor(tier: HavnSubscriptionTier, row: PlanMatrixRow): String {
        val limits = HavnPlans.limitsFor(tier)
        return when (row.key) {
            "price" -> price(tier)
            "properties" -> whole(limits.maxProperties)
            "contacts" -> whole(limits.maxContacts)
            "openings" -> whole(limits.maxOpenings)
            "leads" -> whole(limits.maxLeads)
            "photos" -> whole(limits.maxPhotosPerProperty)
            "documents" -> whole(limits.maxDocumentsPerProperty)
            "storage" -> bytes(limits.documentsStorageBytes)
            "agency" -> yesNo(limits.hasAgencyAgenda)
            "ai" -> if (limits.aiTextGenerationRequestsPerMonth == 0) strings.compareValueNo else whole(limits.aiTextGenerationRequestsPerMonth)
            "analytics" -> yesNo(limits.hasAnalytics)
            "reports" -> yesNo(limits.hasSellerReports)
            "tasks" -> yesNo(limits.hasTasks)
            "owner_storage" -> bytes(limits.documentsStorageBytes)
            "file_size" -> bytes(limits.maxFileSizeBytes)
            "email" -> yesNo(limits.hasEmailSupport)
            "priority" -> yesNo(limits.hasPriorityEmailSupport)
            "backups" -> yesNo(limits.hasDailyBackups7Days)
            "kiosk" -> strings.compareValueYes
            else -> ""
        }
    }
    val rows = listOf(
        PlanMatrixRow(
            "price",
            if (selectedPeriod == HavnBillingPeriod.Monthly) strings.comparePricePerMonthUser else strings.comparePricePerYearUser,
            HavnIconKey.Star
        ),
        PlanMatrixRow("properties", strings.compareMaxPropertiesOwner, HavnIconKey.Properties),
        PlanMatrixRow("contacts", strings.compareMaxContactsOwner, HavnIconKey.ContactCard),
        PlanMatrixRow("openings", strings.compareMaxOpenHousesOwner, HavnIconKey.CalendarClock),
        PlanMatrixRow("leads", strings.compareMaxLeadsOwner, HavnIconKey.Leads),
        PlanMatrixRow("photos", strings.compareMaxPhotosProperty, HavnIconKey.Properties),
        PlanMatrixRow("documents", strings.compareMaxDocumentsProperty, HavnIconKey.Note),
        PlanMatrixRow("storage", strings.compareDocumentsStorage, HavnIconKey.Note),
        PlanMatrixRow("agency", strings.compareAgencyAgenda, HavnIconKey.Building),
        PlanMatrixRow("ai", strings.compareAiTextRequestsMonth, HavnIconKey.Message),
        PlanMatrixRow("analytics", strings.compareAnalytics, HavnIconKey.Chart),
        PlanMatrixRow("reports", strings.compareSellerReports, HavnIconKey.Reports),
        PlanMatrixRow("tasks", strings.compareTasks, HavnIconKey.Check),
        PlanMatrixRow("owner_storage", strings.compareDocumentsStorageOwner, HavnIconKey.Note),
        PlanMatrixRow("file_size", strings.compareMaxFileSizeOwner, HavnIconKey.Note),
        PlanMatrixRow("email", strings.compareEmailSupport, HavnIconKey.Message),
        PlanMatrixRow("priority", strings.comparePrioritySupport, HavnIconKey.Alert),
        PlanMatrixRow("backups", strings.compareDailyBackups7Days, HavnIconKey.CalendarClock),
        PlanMatrixRow("kiosk", strings.compareKioskMode, HavnIconKey.QrCode)
    )

    BoxWithConstraints(Modifier.fillMaxWidth()) {
        val usePhoneCompare = !havnIsWebShell && maxWidth < 600.dp
        val selectedTier = HavnSubscriptionTier.fromDatabase(selectedPlan)
        if (usePhoneCompare) {
            PhonePlanComparison(
                tiers = tiers,
                selectedTier = selectedTier,
                planName = ::planName,
                rows = rows,
                valueFor = ::valueFor,
                yesValue = strings.compareValueYes,
                noValue = strings.compareValueNo,
                onSelectPlan = onSelectPlan
            )
        } else {
            ClassicPlanComparisonCard(
                tiers = tiers,
                selectedTier = selectedTier,
                planName = ::planName,
                rows = rows,
                valueFor = ::valueFor,
                featureLabel = strings.compareFeature,
                onSelectPlan = onSelectPlan
            )
        }
    }
}

@Composable
private fun PhonePlanComparison(
    tiers: List<HavnSubscriptionTier>,
    selectedTier: HavnSubscriptionTier,
    planName: (HavnSubscriptionTier) -> String,
    rows: List<PlanMatrixRow>,
    valueFor: (HavnSubscriptionTier, PlanMatrixRow) -> String,
    yesValue: String,
    noValue: String,
    onSelectPlan: (String) -> Unit
) {
    var compareTier by remember(selectedTier) { mutableStateOf(selectedTier) }
    Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
        HavnSegmentedControl(
            items = tiers.map { tier -> tier to planName(tier) },
            selectedItem = compareTier,
            onItemSelected = { tier ->
                compareTier = tier
                if (tier != HavnSubscriptionTier.Free) {
                    onSelectPlan(tier.databaseValue)
                }
            }
        )
        Surface(
            modifier = Modifier.fillMaxWidth(),
            shape = MaterialTheme.shapes.large,
            color = LocalHavnThemeTokens.current.card,
            border = BorderStroke(1.dp, LocalHavnThemeTokens.current.border)
        ) {
            Column(modifier = Modifier.padding(vertical = HavnSpacing.xs)) {
                rows.forEach { row ->
                    PhoneCompareFeatureRow(
                        row = row,
                        value = valueFor(compareTier, row),
                        yesValue = yesValue,
                        noValue = noValue
                    )
                }
            }
        }
    }
}

@Composable
private fun PhoneCompareFeatureRow(
    row: PlanMatrixRow,
    value: String,
    yesValue: String,
    noValue: String
) {
    val theme = LocalHavnThemeTokens.current
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .heightIn(min = 56.dp)
            .background(theme.background.copy(alpha = 0.18f))
            .padding(horizontal = HavnSpacing.md, vertical = HavnSpacing.sm),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm)
    ) {
        HavnIcon(row.icon, contentDescription = null, tint = theme.primaryAccent, modifier = Modifier.size(16.dp))
        Text(
            text = row.feature,
            modifier = Modifier.weight(1f),
            color = theme.secondaryText,
            style = MaterialTheme.typography.bodyMedium,
            maxLines = 2,
            overflow = TextOverflow.Ellipsis
        )
        if (value == yesValue) {
            HavnIcon(HavnIconKey.Check, contentDescription = null, tint = theme.primaryAccent, modifier = Modifier.size(20.dp))
        } else {
            Text(
                text = value,
                color = if (value == noValue || value == "0") theme.mutedText else theme.primaryText,
                style = MaterialTheme.typography.labelLarge,
                textAlign = androidx.compose.ui.text.style.TextAlign.End,
                maxLines = 2,
                overflow = TextOverflow.Ellipsis
            )
        }
    }
}

@Composable
private fun ClassicPlanComparisonCard(
    tiers: List<HavnSubscriptionTier>,
    selectedTier: HavnSubscriptionTier,
    planName: (HavnSubscriptionTier) -> String,
    rows: List<PlanMatrixRow>,
    valueFor: (HavnSubscriptionTier, PlanMatrixRow) -> String,
    featureLabel: String,
    onSelectPlan: (String) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    BoxWithConstraints(Modifier.fillMaxWidth()) {
        val tableWidth = if (maxWidth < 940.dp) 940.dp else maxWidth
        Box(modifier = Modifier.fillMaxWidth().horizontalScroll(rememberScrollState())) {
            Surface(
                modifier = Modifier.width(tableWidth),
                shape = MaterialTheme.shapes.large,
                color = theme.card,
                border = BorderStroke(1.dp, theme.border)
            ) {
                Column {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .background(theme.background.copy(alpha = 0.28f))
                            .padding(horizontal = HavnSpacing.md, vertical = HavnSpacing.md),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Text(
                            text = featureLabel,
                            modifier = Modifier.weight(1.65f),
                            color = theme.mutedText,
                            style = MaterialTheme.typography.labelLarge
                        )
                        tiers.forEach { tier ->
                            val selected = selectedTier == tier
                            Text(
                                text = planName(tier),
                                modifier = Modifier
                                    .weight(0.8f)
                                    .clip(MaterialTheme.shapes.small)
                                    .clickable(enabled = tier != HavnSubscriptionTier.Free) {
                                        onSelectPlan(tier.databaseValue)
                                    }
                                    .background(if (selected) theme.primaryAccent.copy(alpha = 0.14f) else Color.Transparent)
                                    .padding(vertical = 8.dp, horizontal = 4.dp),
                                color = if (selected) theme.primaryAccent else theme.primaryText,
                                style = MaterialTheme.typography.labelLarge,
                                textAlign = androidx.compose.ui.text.style.TextAlign.Center,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                        }
                    }
                    rows.forEach { row ->
                        ComparePlanRowView(
                            row = row,
                            values = tiers.map { valueFor(it, row) },
                            selectedIndex = tiers.indexOf(selectedTier)
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun ComparePlanRowView(row: ComparePlanRow) {
    val theme = LocalHavnThemeTokens.current
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .heightIn(min = 48.dp)
            .background(theme.background.copy(alpha = 0.28f))
            .padding(horizontal = HavnSpacing.sm, vertical = HavnSpacing.sm),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Row(
            modifier = Modifier.weight(1.28f),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm)
        ) {
            HavnIcon(row.icon, contentDescription = null, tint = theme.primaryAccent, modifier = Modifier.size(16.dp))
            Text(
                text = row.feature,
                color = theme.primaryText,
                style = MaterialTheme.typography.labelLarge,
                maxLines = 2,
                overflow = TextOverflow.Ellipsis
            )
        }
        Text(
            text = row.solo,
            modifier = Modifier.weight(0.78f),
            color = theme.secondaryText,
            style = MaterialTheme.typography.labelLarge,
            textAlign = androidx.compose.ui.text.style.TextAlign.Center
        )
        Box(
            modifier = Modifier.weight(0.78f),
            contentAlignment = Alignment.Center
        ) {
            if (row.proCheck) {
                HavnIcon(HavnIconKey.Check, contentDescription = null, tint = theme.primaryAccent, modifier = Modifier.size(20.dp))
            } else {
                Text(
                    text = row.pro,
                    color = theme.primaryText,
                    style = MaterialTheme.typography.labelLarge,
                    textAlign = androidx.compose.ui.text.style.TextAlign.Center
                )
            }
        }
    }
}

@Composable
private fun ComparePlanRowView(
    row: PlanMatrixRow,
    values: List<String>,
    selectedIndex: Int
) {
    val theme = LocalHavnThemeTokens.current
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .heightIn(min = 48.dp)
            .background(theme.background.copy(alpha = 0.28f))
            .padding(horizontal = HavnSpacing.sm, vertical = HavnSpacing.sm),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Row(
            modifier = Modifier.weight(1.45f),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm)
        ) {
            HavnIcon(row.icon, contentDescription = null, tint = theme.primaryAccent, modifier = Modifier.size(16.dp))
            Text(
                text = row.feature,
                color = theme.primaryText,
                style = MaterialTheme.typography.labelLarge,
                maxLines = 2,
                overflow = TextOverflow.Ellipsis
            )
        }
        values.forEachIndexed { index, value ->
            Text(
                text = value,
                modifier = Modifier
                    .weight(0.72f)
                    .background(if (index == selectedIndex) theme.primaryAccent.copy(alpha = 0.08f) else Color.Transparent)
                    .padding(vertical = 4.dp),
                color = if (index == selectedIndex) theme.primaryText else theme.secondaryText,
                style = MaterialTheme.typography.labelLarge,
                textAlign = androidx.compose.ui.text.style.TextAlign.Center,
                maxLines = 2,
                overflow = TextOverflow.Ellipsis
            )
        }
    }
}

@Composable
private fun CompactComparePlanRowView(
    row: PlanMatrixRow,
    tiers: List<HavnSubscriptionTier>,
    planName: (HavnSubscriptionTier) -> String,
    values: List<String>,
    selectedTier: HavnSubscriptionTier,
    onSelectPlan: (String) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = MaterialTheme.shapes.medium,
        color = theme.card,
        border = BorderStroke(1.dp, theme.border)
    ) {
        Column(
            modifier = Modifier.padding(HavnSpacing.sm),
            verticalArrangement = Arrangement.spacedBy(HavnSpacing.sm)
        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm)
            ) {
                HavnIcon(row.icon, contentDescription = null, tint = theme.primaryAccent, modifier = Modifier.size(16.dp))
                Text(
                    text = row.feature,
                    color = theme.primaryText,
                    style = MaterialTheme.typography.labelLarge,
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis
                )
            }
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(4.dp)
            ) {
                tiers.forEachIndexed { index, tier ->
                    val selected = tier == selectedTier
                    Surface(
                        modifier = Modifier
                            .weight(1f)
                            .heightIn(min = 54.dp)
                            .clip(MaterialTheme.shapes.small)
                            .clickable(enabled = tier != HavnSubscriptionTier.Free) {
                                onSelectPlan(tier.databaseValue)
                            },
                        shape = MaterialTheme.shapes.small,
                        color = if (selected) theme.primaryAccent.copy(alpha = 0.14f) else theme.background.copy(alpha = 0.52f),
                        border = BorderStroke(1.dp, if (selected) theme.primaryAccent else theme.border)
                    ) {
                        Column(
                            modifier = Modifier.padding(horizontal = 3.dp, vertical = 6.dp),
                            horizontalAlignment = Alignment.CenterHorizontally,
                            verticalArrangement = Arrangement.spacedBy(2.dp)
                        ) {
                            Text(
                                text = planName(tier),
                                color = if (selected) theme.primaryAccent else theme.mutedText,
                                style = MaterialTheme.typography.labelSmall,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis,
                                textAlign = androidx.compose.ui.text.style.TextAlign.Center
                            )
                            Text(
                                text = values.getOrElse(index) { "" },
                                color = theme.primaryText,
                                style = MaterialTheme.typography.labelSmall,
                                maxLines = 2,
                                overflow = TextOverflow.Ellipsis,
                                textAlign = androidx.compose.ui.text.style.TextAlign.Center
                            )
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun PriceCell(
    price: String,
    period: HavnBillingPeriod,
    selected: Boolean,
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    val theme = LocalHavnThemeTokens.current
    val strings = LocalHavnStrings.current
    Surface(
        modifier = modifier
            .padding(horizontal = 3.dp)
            .clip(MaterialTheme.shapes.medium)
            .clickable(onClick = onClick),
        shape = MaterialTheme.shapes.medium,
        color = if (selected) theme.primaryAccent.copy(alpha = 0.12f) else theme.background,
        border = BorderStroke(1.dp, if (selected) theme.primaryAccent else theme.border)
    ) {
        Column(
            modifier = Modifier.padding(vertical = HavnSpacing.sm),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Text(price, color = theme.primaryText, style = MaterialTheme.typography.titleMedium)
            Text(
                if (period == HavnBillingPeriod.Yearly) strings.perYear else strings.perMonth,
                color = theme.mutedText,
                style = MaterialTheme.typography.labelMedium
            )
        }
    }
}

@Composable
private fun BillingPeriodSegmentedControl(
    selectedPeriod: HavnBillingPeriod,
    onPeriodSelected: (HavnBillingPeriod) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    val strings = LocalHavnStrings.current
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = MaterialTheme.shapes.large,
        color = theme.card,
        border = BorderStroke(1.dp, theme.border)
    ) {
        Row(modifier = Modifier.padding(4.dp), horizontalArrangement = Arrangement.spacedBy(4.dp)) {
            HavnListFilterChip(
                label = strings.monthly,
                selected = selectedPeriod == HavnBillingPeriod.Monthly,
                onClick = { onPeriodSelected(HavnBillingPeriod.Monthly) },
                modifier = Modifier.weight(1f)
            )
            HavnListFilterChip(
                label = strings.yearlySave20,
                selected = selectedPeriod == HavnBillingPeriod.Yearly,
                onClick = { onPeriodSelected(HavnBillingPeriod.Yearly) },
                modifier = Modifier.weight(1f)
            )
        }
    }
}

private data class ComparePlanRow(
    val icon: HavnIconKey,
    val feature: String,
    val solo: String,
    val pro: String,
    val proCheck: Boolean
)

private data class PlanMatrixRow(
    val key: String,
    val feature: String,
    val icon: HavnIconKey
)

private fun planTitle(tier: HavnSubscriptionTier, strings: HavnStrings): String = when (tier) {
    HavnSubscriptionTier.Free -> strings.compareFreePlan
    HavnSubscriptionTier.SoloAgent -> strings.soloAgentPlan
    HavnSubscriptionTier.ProAgent -> strings.proAgentPlan
    HavnSubscriptionTier.TeamAgent -> strings.teamAgentPlan
}

private fun planIcon(tier: HavnSubscriptionTier): HavnIconKey = when (tier) {
    HavnSubscriptionTier.Free -> HavnIconKey.Check
    HavnSubscriptionTier.SoloAgent -> HavnIconKey.User
    HavnSubscriptionTier.ProAgent -> HavnIconKey.Star
    HavnSubscriptionTier.TeamAgent -> HavnIconKey.Users
}

private fun launchPlanPrice(tier: HavnSubscriptionTier, period: HavnBillingPeriod): String = when (tier to period) {
    HavnSubscriptionTier.Free to HavnBillingPeriod.Monthly -> "\$0"
    HavnSubscriptionTier.Free to HavnBillingPeriod.Yearly -> "\$0"
    HavnSubscriptionTier.SoloAgent to HavnBillingPeriod.Monthly -> "\$9.99"
    HavnSubscriptionTier.SoloAgent to HavnBillingPeriod.Yearly -> "\$99.99"
    HavnSubscriptionTier.ProAgent to HavnBillingPeriod.Monthly -> "\$19.99"
    HavnSubscriptionTier.ProAgent to HavnBillingPeriod.Yearly -> "\$199.99"
    HavnSubscriptionTier.TeamAgent to HavnBillingPeriod.Monthly -> "\$29.99"
    HavnSubscriptionTier.TeamAgent to HavnBillingPeriod.Yearly -> "\$299.99"
    else -> ""
}

private fun effectiveMonthlyPriceLabel(yearlyPrice: String): String? {
    val match = Regex("""\d+(?:[.,]\d+)?""").find(yearlyPrice) ?: return null
    val yearlyAmount = match.value.replace(',', '.').toDoubleOrNull() ?: return null
    val monthlyCents = kotlin.math.round(yearlyAmount * 100.0 / 12.0).toInt()
    val whole = monthlyCents / 100
    val cents = (monthlyCents % 100).toString().padStart(2, '0')
    val prefix = yearlyPrice.take(match.range.first)
    val suffix = yearlyPrice.drop(match.range.last + 1)
    return "$prefix$whole.$cents$suffix"
}

private fun formatPlanNumber(value: Int): String =
    value.toString()
        .reversed()
        .chunked(3)
        .joinToString(",")
        .reversed()

private fun formatPlanBytes(value: Long): String = when (value) {
    0L -> "0"
    104_857_600L -> "100 MB"
    1_073_741_824L -> "1 GB"
    10_737_418_240L -> "10 GB"
    10_485_760L -> "10 MB"
    52_428_800L -> "50 MB"
    else -> "${value / 1_048_576L} MB"
}

@Composable
private fun PlanCard(
    title: String,
    price: String,
    caption: String?,
    icon: HavnIconKey,
    selected: Boolean,
    onClick: () -> Unit,
    benefits: List<String>
) {
    val theme = LocalHavnThemeTokens.current
    Surface(
        modifier = Modifier
            .fillMaxWidth()
            .clip(MaterialTheme.shapes.large)
            .clickable(onClick = onClick),
        shape = MaterialTheme.shapes.large,
        color = theme.surface,
        border = BorderStroke(1.dp, if (selected) theme.primaryAccent else theme.border)
    ) {
        Column(
            modifier = Modifier.padding(HavnSpacing.md),
            verticalArrangement = Arrangement.spacedBy(HavnSpacing.sm)
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(HavnSpacing.md)
            ) {
                Column(
                    modifier = Modifier.weight(1f),
                    verticalArrangement = Arrangement.spacedBy(2.dp)
                ) {
                    Text(title, color = theme.primaryText, style = MaterialTheme.typography.titleLarge)
                    Text(price, color = theme.primaryText, style = MaterialTheme.typography.bodyLarge)
                    caption?.let {
                        Text(
                            text = it,
                            color = theme.primaryAccent,
                            style = MaterialTheme.typography.labelLarge,
                            maxLines = 2,
                            overflow = TextOverflow.Ellipsis
                        )
                    }
                }
                Surface(
                    modifier = Modifier.size(52.dp),
                    shape = MaterialTheme.shapes.large,
                    color = if (selected) theme.primaryAccent.copy(alpha = 0.28f) else theme.background,
                    border = BorderStroke(1.dp, if (selected) theme.primaryAccent else theme.border)
                ) {
                    Box(contentAlignment = Alignment.Center) {
                        HavnIcon(
                            icon = icon,
                            contentDescription = null,
                            tint = if (selected) theme.primaryAccent else theme.mutedText,
                            modifier = Modifier.size(24.dp)
                        )
                    }
                }
            }
            benefits.forEach { benefit ->
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm)
                ) {
                    HavnIcon(
                        icon = HavnIconKey.Check,
                        contentDescription = null,
                        tint = theme.primaryAccent,
                        modifier = Modifier.size(15.dp)
                    )
                    Text(benefit, color = theme.secondaryText, style = MaterialTheme.typography.bodyMedium)
                }
            }
        }
    }
}

@Composable
private fun AgencyOptionRow(
    agency: Agency,
    selected: Boolean,
    enabled: Boolean,
    canUseAgency: Boolean,
    onClick: () -> Unit
) {
    val strings = LocalHavnStrings.current
    WorkspaceOptionRow(
        title = agency.name,
        body = if (canUseAgency) {
            "${agency.role.databaseValue.toSentenceCaseLabel()} - ${agency.memberCount} ${strings.members}"
        } else {
            strings.upgradeToProForAgencyTools
        },
        selected = selected,
        enabled = enabled,
        onClick = onClick
    )
}

private fun HavnThemeType.localizedName(strings: com.havn.app.core.localization.HavnStrings): String = when (this) {
    HavnThemeType.LIGHT -> "Light"
    HavnThemeType.OBSIDIAN_GOLD -> "Dark"
    HavnThemeType.MIDNIGHT_SAPPHIRE -> strings.themeMidnightSapphireName
    HavnThemeType.EMERALD_ESTATE -> strings.themeEmeraldEstateName
    HavnThemeType.PLATINUM_STONE -> strings.themePlatinumStoneName
    HavnThemeType.BORDEAUX_NOIR -> strings.themeBordeauxNoirName
}

private fun HavnThemeType.localizedDescription(strings: com.havn.app.core.localization.HavnStrings): String = when (this) {
    HavnThemeType.LIGHT -> "Warm ivory, black text, and HAVN gold."
    HavnThemeType.OBSIDIAN_GOLD -> "Luxury black, graphite, and HAVN gold."
    HavnThemeType.MIDNIGHT_SAPPHIRE -> strings.themeMidnightSapphireDescription
    HavnThemeType.EMERALD_ESTATE -> strings.themeEmeraldEstateDescription
    HavnThemeType.PLATINUM_STONE -> strings.themePlatinumStoneDescription
    HavnThemeType.BORDEAUX_NOIR -> strings.themeBordeauxNoirDescription
}

@Composable
private fun WorkspaceOptionRow(
    title: String,
    body: String,
    selected: Boolean,
    enabled: Boolean,
    onClick: () -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    val borderColor = if (selected) theme.primaryAccent else theme.border
    val textColor = if (enabled) theme.primaryText else theme.mutedText
    Surface(
        modifier = Modifier
            .fillMaxWidth()
            .clip(MaterialTheme.shapes.medium)
            .clickable(enabled = enabled, onClick = onClick),
        shape = MaterialTheme.shapes.medium,
        color = if (selected) theme.primaryAccent.copy(alpha = 0.12f) else theme.card,
        border = BorderStroke(1.dp, borderColor)
    ) {
        Row(
            modifier = Modifier.padding(HavnSpacing.md),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(HavnSpacing.md)
        ) {
            Surface(
                modifier = Modifier.size(34.dp),
                shape = MaterialTheme.shapes.small,
                color = if (selected) theme.primaryAccent else theme.background,
                border = BorderStroke(1.dp, borderColor)
            ) {
                Box(contentAlignment = Alignment.Center) {
                    HavnIcon(
                        icon = if (selected) HavnIconKey.Check else HavnIconKey.Home,
                        contentDescription = null,
                        tint = if (selected) theme.background else theme.primaryAccent,
                        modifier = Modifier.size(17.dp)
                    )
                }
            }
            Column(modifier = Modifier.weight(1f)) {
                Text(
                    text = title,
                    color = textColor,
                    style = MaterialTheme.typography.bodyLarge,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Text(
                    text = body,
                    color = theme.mutedText,
                    style = MaterialTheme.typography.labelMedium,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            }
        }
    }
}

@Composable
private fun MeasurementSegmentedControl(
    selectedSystem: HavnMeasurementSystem,
    onSystemSelected: (HavnMeasurementSystem) -> Unit
) {
    val strings = LocalHavnStrings.current
    HavnSegmentedControl(
        items = listOf(
            HavnMeasurementSystem.Metric to strings.metric,
            HavnMeasurementSystem.Imperial to strings.imperial
        ),
        selectedItem = selectedSystem,
        onItemSelected = onSystemSelected
    )
}

@Composable
private fun CurrencyComboBox(
    selectedCurrency: HavnCurrency,
    onCurrencySelected: (HavnCurrency) -> Unit
) {
    var expanded by remember { mutableStateOf(false) }
    val theme = LocalHavnThemeTokens.current
    Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.sm)) {
        Surface(
            modifier = Modifier
                .fillMaxWidth()
                .clickable { expanded = !expanded },
            shape = MaterialTheme.shapes.medium,
            color = theme.surface,
            border = BorderStroke(1.dp, theme.border)
        ) {
            CurrencyOptionRow(
                currency = selectedCurrency,
                trailingIcon = HavnIconKey.ArrowRight
            )
        }
        if (expanded) {
            Surface(
                modifier = Modifier.fillMaxWidth(),
                shape = MaterialTheme.shapes.medium,
                color = theme.surface,
                border = BorderStroke(1.dp, theme.border)
            ) {
                Column(modifier = Modifier.padding(vertical = HavnSpacing.xs)) {
                    HavnCurrency.entries.forEach { currency ->
                        Box(
                            modifier = Modifier
                                .fillMaxWidth()
                                .clip(MaterialTheme.shapes.small)
                                .clickable {
                                    expanded = false
                                    onCurrencySelected(currency)
                                }
                        ) {
                            CurrencyOptionRow(
                                currency = currency,
                                selected = currency == selectedCurrency
                            )
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun CurrencyOptionRow(
    currency: HavnCurrency,
    selected: Boolean = false,
    trailingIcon: HavnIconKey? = null
) {
    val theme = LocalHavnThemeTokens.current
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .heightIn(min = 54.dp)
            .background(if (selected) theme.primaryAccent.copy(alpha = 0.14f) else theme.surface)
            .padding(horizontal = HavnSpacing.md, vertical = HavnSpacing.sm),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm)
    ) {
        Text(
            text = currency.symbol,
            modifier = Modifier
                .size(38.dp)
                .clip(MaterialTheme.shapes.extraSmall)
                .background(theme.background.copy(alpha = 0.62f))
                .padding(vertical = HavnSpacing.sm),
            color = theme.primaryAccent,
            style = MaterialTheme.typography.labelLarge,
            maxLines = 1,
            textAlign = androidx.compose.ui.text.style.TextAlign.Center
        )
        Column(modifier = Modifier.weight(1f)) {
            Text(
                text = currency.code,
                color = theme.primaryText,
                style = MaterialTheme.typography.bodyLarge,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
            Text(
                text = currency.displayName,
                color = theme.mutedText,
                style = MaterialTheme.typography.labelMedium,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
        when {
            selected -> HavnIcon(
                icon = HavnIconKey.Check,
                contentDescription = null,
                tint = theme.primaryAccent
            )
            trailingIcon != null -> HavnIcon(
                icon = trailingIcon,
                contentDescription = null,
                tint = theme.primaryAccent
            )
        }
    }
}

@Composable
private fun LanguageComboBox(
    selectedLanguage: HavnLanguage,
    onLanguageSelected: (HavnLanguage) -> Unit
) {
    var expanded by remember { mutableStateOf(false) }
    val theme = LocalHavnThemeTokens.current
    Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.sm)) {
        Surface(
            modifier = Modifier
                .fillMaxWidth()
                .clickable { expanded = !expanded },
            shape = MaterialTheme.shapes.medium,
            color = theme.surface,
            border = BorderStroke(1.dp, theme.border)
        ) {
            LanguageOptionRow(
                language = selectedLanguage,
                trailingIcon = HavnIconKey.ArrowRight
            )
        }
        if (expanded) {
            Surface(
                modifier = Modifier.fillMaxWidth(),
                shape = MaterialTheme.shapes.medium,
                color = theme.surface,
                border = BorderStroke(1.dp, theme.border)
            ) {
                Column(modifier = Modifier.padding(vertical = HavnSpacing.xs)) {
                    HavnLanguage.entries.forEach { language ->
                        Box(
                            modifier = Modifier
                                .fillMaxWidth()
                                .clip(MaterialTheme.shapes.small)
                                .clickable {
                                    expanded = false
                                    onLanguageSelected(language)
                                }
                        ) {
                            LanguageOptionRow(
                                language = language,
                                selected = language == selectedLanguage
                            )
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun LanguageOptionRow(
    language: HavnLanguage,
    selected: Boolean = false,
    trailingIcon: HavnIconKey? = null
) {
    val theme = LocalHavnThemeTokens.current
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .heightIn(min = 54.dp)
            .background(if (selected) theme.primaryAccent.copy(alpha = 0.14f) else theme.surface)
            .padding(horizontal = HavnSpacing.md, vertical = HavnSpacing.sm),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm)
    ) {
        LanguageFlag(language)
        Column(modifier = Modifier.weight(1f)) {
            Text(
                text = language.nativeName,
                color = theme.primaryText,
                style = MaterialTheme.typography.bodyLarge,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
            Text(
                text = language.displayName,
                color = theme.mutedText,
                style = MaterialTheme.typography.labelMedium,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
        when {
            selected -> HavnIcon(
                icon = HavnIconKey.Check,
                contentDescription = null,
                tint = theme.primaryAccent
            )
            trailingIcon != null -> HavnIcon(
                icon = trailingIcon,
                contentDescription = null,
                tint = theme.primaryAccent
            )
        }
    }
}

@Composable
private fun LanguageFlag(language: HavnLanguage) {
    val theme = LocalHavnThemeTokens.current
    Surface(
        modifier = Modifier.size(width = 38.dp, height = 26.dp),
        shape = MaterialTheme.shapes.extraSmall,
        color = theme.surface,
        border = BorderStroke(1.dp, theme.border)
    ) {
        Canvas(Modifier.fillMaxSize()) {
            fun horizontal(colors: List<Color>) {
                val stripeHeight = size.height / colors.size
                colors.forEachIndexed { index, color ->
                    drawRect(
                        color = color,
                        topLeft = Offset(0f, stripeHeight * index),
                        size = Size(size.width, stripeHeight + 0.5f)
                    )
                }
            }

            fun vertical(colors: List<Color>) {
                val stripeWidth = size.width / colors.size
                colors.forEachIndexed { index, color ->
                    drawRect(
                        color = color,
                        topLeft = Offset(stripeWidth * index, 0f),
                        size = Size(stripeWidth + 0.5f, size.height)
                    )
                }
            }

            when (language) {
                HavnLanguage.English -> {
                    horizontal(
                        listOf(
                            Color(0xFFB22234),
                            Color.White,
                            Color(0xFFB22234),
                            Color.White,
                            Color(0xFFB22234),
                            Color.White,
                            Color(0xFFB22234)
                        )
                    )
                    drawRect(Color(0xFF3C3B6E), size = Size(size.width * 0.45f, size.height * 0.54f))
                }
                HavnLanguage.Slovak -> {
                    horizontal(listOf(Color.White, Color(0xFF0B4EA2), Color(0xFFEE1C25)))
                    drawCircle(Color(0xFFEE1C25), radius = size.height * 0.18f, center = Offset(size.width * 0.32f, size.height * 0.5f))
                }
                HavnLanguage.German -> horizontal(listOf(Color(0xFF111111), Color(0xFFDD0000), Color(0xFFFFCE00)))
                HavnLanguage.French -> vertical(listOf(Color(0xFF0055A4), Color.White, Color(0xFFEF4135)))
                HavnLanguage.Czech -> {
                    horizontal(listOf(Color.White, Color(0xFFD7141A)))
                    drawPath(
                        path = androidx.compose.ui.graphics.Path().apply {
                            moveTo(0f, 0f)
                            lineTo(size.width * 0.48f, size.height * 0.5f)
                            lineTo(0f, size.height)
                            close()
                        },
                        color = Color(0xFF11457E)
                    )
                }
                HavnLanguage.Spanish -> horizontal(listOf(Color(0xFFC60B1E), Color(0xFFFFC400), Color(0xFFFFC400), Color(0xFFC60B1E)))
                HavnLanguage.Italian -> vertical(listOf(Color(0xFF009246), Color.White, Color(0xFFCE2B37)))
                HavnLanguage.Croatian -> horizontal(listOf(Color(0xFFFF0000), Color.White, Color(0xFF171796)))
                HavnLanguage.Portuguese -> vertical(listOf(Color(0xFF006600), Color(0xFFFF0000)))
                HavnLanguage.Dutch -> horizontal(listOf(Color(0xFFAE1C28), Color.White, Color(0xFF21468B)))
                HavnLanguage.Polish -> horizontal(listOf(Color.White, Color(0xFFDC143C)))
                HavnLanguage.Hungarian -> horizontal(listOf(Color(0xFFCE2939), Color.White, Color(0xFF477050)))
                HavnLanguage.Romanian -> vertical(listOf(Color(0xFF002B7F), Color(0xFFFCD116), Color(0xFFCE1126)))
            }
        }
    }
}

@Composable
private fun <T> HavnSegmentedControl(
    items: List<Pair<T, String>>,
    selectedItem: T,
    onItemSelected: (T) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = MaterialTheme.shapes.medium,
        color = theme.surface,
        border = BorderStroke(1.dp, theme.border)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(3.dp),
            horizontalArrangement = Arrangement.spacedBy(4.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            items.forEach { item ->
                val (value, label) = item
                val selected = selectedItem == value
                HavnListFilterChip(
                    label = label,
                    selected = selected,
                    onClick = { onItemSelected(value) },
                    modifier = Modifier.weight(1f)
                )
            }
        }
    }
}

private fun String.toSentenceCaseLabel(): String =
    replace("_", " ")
        .lowercase()
        .replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() }
